import { DatePipe } from '@angular/common';
import { Component, ElementRef, Inject, OnInit, Optional, QueryList, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSidenav } from '@angular/material/sidenav';
import { MatTableDataSource } from '@angular/material/table';
import { CounselorService } from 'app/EMR/Counselor/counselor.service';
import { DiagnosisComponent } from 'app/EMR/Diagnosis/Diagnosis.component';
import { EMRService } from 'app/EMR/EMR.service';
import { AuthService } from 'app/auth/auth.service';
import { BillingserviceService } from 'app/billing/billingService.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { IPDService } from 'app/ipd/Services/ipdServices.service';
import { DischargeSUmmeryModel } from 'app/ipd/models/dischargeSummery.Model';
import { CounselorPreOpInstructionDetail } from 'app/ipd/models/get-pre-op-template-master';
import { ByIPDWorkup, GetIPDLocation, RoutineExam, UserMaster } from 'app/ipd/models/ipdDashboardModel';
import { GetCounselorPreOpMedicineModel, GetNursingChartModel, GetNursingMedicineModel, IpdvisitDiagnosisModel, IpdvisitExamModel, IpdvisitInvestModel, IpdvisitPrescModel, NursingInstructionsModel, getIPDExamList } from 'app/ipd/models/nursingWorkup.Model';
import { IPDsurgicalRecordModel, OtRecordSurgeryModel, OtcaseSheetModel } from 'app/ipd/models/surgicalRecordModel';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import * as moment from 'moment';
import { Observable, Subject, fromEvent, interval } from 'rxjs';
import { exhaustMap, map, startWith, take, takeUntil, tap } from 'rxjs/operators';
import { HelpListPopupComponent } from '../doctor-other-info/help-list-popup/help-list-popup.component';
import { CommanSurgeryPopupComponent } from 'app/EMR/NewSurgery/comman-surgery-popup/comman-surgery-popup.component';
import { AnestheticRecordModel, AnestheticVisitDetailModel, GetPreOpAssesmentDetailHistroy, PreopAssesmentRecordModel } from 'app/ipd/models/PreOpAssesmentDetail.Model';
import { DynamicHelpListComponent } from '../doctor-other-info/dynamic-help-list/dynamic-help-list.component';
import { IpdIolModel } from 'app/ipd/models/ipdIOL.model';

@Component({
  selector: 'app-inhouse-surgeries',
  templateUrl: './inhouse-surgeries.component.html',
  styleUrls: ['./inhouse-surgeries.component.scss'],
   encapsulation:ViewEncapsulation.Emulated
})
export class InhouseSurgeriesComponent implements OnInit{
  destroyipd$: Subject<boolean> = new Subject<boolean>();
  private surgicalRecordobj: IPDsurgicalRecordModel = {};
  dataSourceWorkup = new MatTableDataSource<ByIPDWorkup>();
  dataSource = new MatTableDataSource<UserMaster>();
  @ViewChild(MatSidenav, { static: false }) sidenav: MatSidenav;
  private selectedTabIndex: number = 0;
  private labelName: any;
  private masterListData: any;
  private selectCouncelorId: number;
  private filteredDoctorArray: Observable<any[]>;
  private filteredOpTypeArray: Observable<any[]>;
  private DoctorCtrl: FormControl;
  private OpTypeCtrl: FormControl;
  private OpTypeCtrl1: FormControl;
  private DoctorCtrl1: FormControl;
  private DoctorCtrl2: FormControl;
  private DoctorCtrl3: FormControl;
  private DoctorCtrl4: FormControl;
  private DoctorCtrl5: FormControl;
  private DoctorCtrl6: FormControl;
  private DoctorCtrl7: FormControl;
  private DoctorCtrl8: FormControl;
  private OTTheatreCtrl: FormControl;
  private OtgroupCtrl: FormControl;
  private OperenedCtrl: FormControl;
  private examTypeCtrledit: FormControl;
  private OTTheatreName: any;
  private RoomCategory: FormControl;
  private OTTheatreCtrl1: FormControl;
  private rightTypeCtrledit: FormControl;
  private leftTypeCtrledit: FormControl;
  private selectIpdId:any;
  private consId: number;
  private newdoctorenablebtn: boolean = false;
  private CounselorInstructionDetail: CounselorPreOpInstructionDetail[] = [];
  destroyemr$: Subject<boolean> = new Subject<boolean>();

  private selecttime: string;
  private timeFormatcheck: any;
  private selectedRoutineExam: RoutineExam = {};
  private RegId: any = 0;
  private filteredOTTheatreArray: Observable<any[]>;
  private getOTArray: any = [];
  private getOtTheatreArray: any = [];
  private corporateData: any;
  private masterData: any;
  private IOLgetData: any;
  private prerecordlength: any;
  private sitelist: any = [];
  private getpospondArray: any = [];
  private TotalNotyetReported: any = 0;
  private admssionById: any;
  private filteredOperenedArray: Observable<any[]>;
  private getotRegdata: any;
  private OTpackageName: any;
  private ipdAmount: any;
  private admissionTo: any;
  private CounspreopDisable: boolean = true;


  private OtcaseSheetArray: OtcaseSheetModel[] = [];

  


  private InstructionsCtrl: FormControl;
  private getOPTypeArray: any = [];
  private opTypeName: any;
  private opTypeId: any = 0;
  private dischargeDatamodel: DischargeSUmmeryModel = {};
  private getipddischargeData: any = [];
  private showspinner1: boolean = false;
  private filteredOtGroupArray: Observable<any[]>;
  private getipdLocation: GetIPDLocation[] = [];
  private masterDataList: any[];
  private patIpdlist: any = {};
  private filteredRoomArray: Observable<any[]>;
  private currentIndex = 0;
  private OtcaseSheetobj: OtcaseSheetModel = {};
  private IOLBookingData: any;
  private rowClickedipdDoctor: any;



  myFormGroup = new FormGroup({
    formField: new FormControl(),
  });


  constructor(
    private ipdService: IPDService,
    private dashboardService: DashboardService,
    private authService: AuthService,
    private opdvisitService: OpdVisitService,
    private datePipe: DatePipe,
    private dialog: MatDialog,
    private emrservice: EMRService,
    private billingservice: BillingserviceService,
    @Optional() @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<InhouseSurgeriesComponent>,

    private counselorService: CounselorService,
  ) { 
    this.selectIpdId = this.data.pkdta
    // console.log(this.selectIpdId ,'called data') 
  }
  handleResponse2(): any {
    return {
      next: (res) => {
       
        this.InsertOtRegisterdata();
      },
      error: (err) => { },
    };
  }
  // datalist:any
  // inhouseseugery(regid){
  //   this.emrservice.inhouseSurgeries(regid).pipe(takeUntil(this.destroyemr$)).subscribe((data:any) => {
  //        console.log(data,'called listttt ipdid')
  //      this.datalist= data.pK_IPDId;
  //      console.log(this.datalist ,'called')
  //      });
    
  // }

  ngOnInit(): void {
    this.GetSurgeryOtRegister(this.selectIpdId);
    // this.inhouseseugery(this.datalist)
     this.selectedTabIndex=0;
    this.opdvisitService.doctors = [];
    //  this.opdvisitService.patientdetails = {};
    this.opdvisitService.callsepecificApi = "ALL";
    // this.pageheadType = "N";
    this.timeFormatcheck = "AM";
    this.DoctorCtrl1 = new FormControl();
    this.DoctorCtrl2 = new FormControl();
    this.DoctorCtrl3 = new FormControl();
    this.DoctorCtrl4 = new FormControl();
    this.DoctorCtrl5 = new FormControl();
    this.DoctorCtrl6 = new FormControl();
    this.DoctorCtrl7 = new FormControl();
    this.DoctorCtrl8 = new FormControl();
    this.InstructionsCtrl = new FormControl();
    this.OpTypeCtrl1 = new FormControl();
    this.OTTheatreCtrl1 = new FormControl();
     this.GetLocationData();
     this.GetotData();
    this.GetotTypeData();
     this.GetOtTheatreData();
     this.OpTypeControll();
     this.OTThreateControll();
     this.doctorControll();
    this.GetPostponedData();
    this.GetNotYetReported();
    this.getRoomCategoryMaster();
    this.CurrentPatient(0);
    this.getDoctorBrach();
    this.OtGroupControll();
    this.PosponedControll();
    // this.headerChecked = true;
     this.getAnesthesiaMasterList();
    // this.PreOpListControll();
    // this.getInstructiondata(0);
    this.getSite();
    // this.getproductmasterconfig();
    // this.GetFindingGroupdata(0, 0);
    // this.ExamTypeControlledit();
    // this.GetFindingGroupResult(0);
    // this.rightTypeControlledit();
    // this.leftTypeControlledit();
    // this.getBranchDetail(this.authService.Loggeduser.branchid);
    this.GetRateType();
    this.selectedTabIndex=0;
    this.OpTypeControll();
  }
  @ViewChild("inertSurgerybtn", { static: true }) button2;
  @ViewChildren("defaultauto") defaultautoRef: QueryList<ElementRef>;
  @ViewChildren("defaultTemp") defaulttemplate: QueryList<ElementRef>;
  @ViewChildren("defaultIns") defaultInstruction: QueryList<ElementRef>;
  @ViewChildren("defaultInsCons") defaultConsInstruction: QueryList<ElementRef>;
  @ViewChildren("Postauto") defaultPostauto: QueryList<ElementRef>;
  // @ViewChild("sertDrExaminationbtn", { static: true }) button;
  // @ViewChild("sertDrdrugExaminationbtn", { static: true }) button1;
  // @ViewChild("TemplateSave", { static: true }) button3;
  clicks$: Observable<any>;
  createUser(): Observable<any> {
    return interval(500).pipe(take(1));
  }
  ngAfterViewInit(): void {
    // fromEvent(this.button.nativeElement, "click")
    //   .pipe(
    //     tap((x) => (this.showspinner1 = true)),
    //     exhaustMap((ev) => {
    //       return this.createUser();
    //     })
    //   )
    //   .subscribe(this.handleResponse());

    // fromEvent(this.button1.nativeElement, "click")
    //   .pipe(
    //     tap((x) => (this.showspinner1 = true)),
    //     exhaustMap((ev) => {
    //       return this.createUser();
    //     })
    //   )
    //   .subscribe(this.handleResponse1());

    fromEvent(this.button2.nativeElement, "click")
      .pipe(
        tap((x) => (this.showspinner1 = true)),
        exhaustMap((ev) => {
          return this.createUser();
        })
      )
      .subscribe(this.handleResponse2());

    // fromEvent(this.button3.nativeElement, 'click')
    // .pipe(
    //   tap((x) => this.showspinner1 = true),
    //   exhaustMap((ev) => {
    //     return this.createUser();
    //   })
    // )
    // .subscribe(this.handleResponse3());
  }
  // medicine sheet given by nurse

  CounselorInstructionAddRow() {
    this.CounspreopDisable = false;
    const templist = {
      pK_TranId: 0,
      fK_CounsID: this.selectCouncelorId,
      instructions: "",
      isActive: true,
      isEdit: false,
      isDelete: false,
    };
    this.CounselorInstructionDetail.push(templist);
    this.defaultConsInstruction.changes.pipe(take(1)).pipe(takeUntil(this.destroyipd$)).subscribe({
      next: (changes) => changes.last.nativeElement.focus(),
    });
  }
  GetNursingMedicineArray: GetNursingMedicineModel[] = [];
  GetNursingMedicineDetail() {
    this.ipdService.GetNursingMedicine(this.selectIpdId).pipe(takeUntil(this.destroyipd$)).subscribe(
      (x: any) => {
        this.GetNursingMedicineArray = [];
        if (x.length > 0) {
          this.GetNursingMedicineArray = x;
        }
      },
      (err) => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      }
    );
  }
  saveNursingData() {
    this.showspinner1 = true;
    this.saveNursingChart();
    if (this.GetNursingChartArray.length > 0) {
      this.insertNursingChartDetail();
    }
    if (this.GetNursingMedicineArray.length > 0) {
      this.InsertNursingMedicinedetail();
    }
  }
  //Nurse Given time Modal
  giventimeindex: number = -1;
  NurseopenModalDialog(e: any, index: number, id: any) {
    if (id > 0 && e == null) {
      this.giventimeindex = index;
      document.getElementById("NurseGIventime").style.display = "block";
    } else if (id == 0) {
      this.giventimeindex = -1;
      document.getElementById("NurseNotGIventime").style.display = "block";
    }
  }


  CloseNursegivenModalDialog() {
    this.giventimeindex = -1;
    document.getElementById("NurseGIventime").style.display = "none";
  }
  NurseNotGIventime() {
    this.giventimeindex = -1;
    document.getElementById("NurseNotGIventime").style.display = "none";
  }
  // insert /update medicine
  InsertNursingMedicinedetail() {
    let payload = {
      NursingMedicineDetail: this.GetNursingMedicineArray,
    };
    this.ipdService.InsertNursingMedicine(payload).pipe(takeUntil(this.destroyipd$)).subscribe(
      (x) => {
        this.GetNursingMedicineDetail();
        this.CloseNursegivenModalDialog();
        this.showspinner1 = false;
      },
      (err) => {
        this.showspinner1 = false;
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      }
    );
  }
  // pre operative medicine
  GetCounselorPreOpMedicineArray: GetCounselorPreOpMedicineModel[] = [];
  GetCounselorPreOpMedicinedetail(counlorid) {
    this.ipdService.GetCounselorPreOpMedicine(counlorid).pipe(takeUntil(this.destroyipd$)).subscribe(
      (x: any) => {
        this.GetCounselorPreOpMedicineArray = [];
        if (x.length > 0) {
          this.GetCounselorPreOpMedicineArray = x;
        }
      },
      (err) => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      }
    );
  }
  insertNursingChartDetail() {
    this.GetNursingChartArray?.forEach((item, i) => {
      if (item.pK_NursingChartId == 0) {
        (item.fK_CreatedById = this.authService.Loggeduser.userid),
          (item.createdBy = this.authService.Loggeduser.firstname);
      }
    });

    this.GetNursingChartArray.map(
      (item) => (item.createdBy = this.authService.Loggeduser.firstname)
    ).indexOf("0");
    let payload = {
      NursingChart: this.GetNursingChartArray,
    };
    this.ipdService.insertNursingChart(payload).pipe(takeUntil(this.destroyipd$)).subscribe(
      (x) => {
        this.GetNursingChartdata();
        this.showspinner1 = false;
      },
      (err) => {
        this.showspinner1 = false;
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      }
    );
  }

  saveNursingChart() {
    let Payload = {
      NursingInstructions: {
        pK_TranId: this.GetNursingInstructionobj.pK_TranId
          ? this.GetNursingInstructionobj.pK_TranId
          : 0,
        fK_IPDId: this.selectIpdId,
        doctorinstructions: this.GetNursingInstructionobj.doctorinstructions,
        nursinginstructions: this.GetNursingInstructionobj.nursinginstructions,
        nursingCarePlan: this.GetNursingInstructionobj.nursingCarePlan,
        nutritionalAdvise: this.GetNursingInstructionobj.nutritionalAdvise,
        IsEdit: this.GetNursingInstructionobj.pK_TranId > 0 ? true : false,
        IsDelete: false,
      },
    };
    this.ipdService.InsertNursingInstructions(Payload).pipe(takeUntil(this.destroyipd$)).subscribe(
      (x) => {
        this.GetNursingInstructiondata();
        this.showspinner1 = false;
        this.dashboardService.openSnackBar("Record Saved Successfully", "OK");
      },
      (err) => {
        this.showspinner1 = false;
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      }
    );
  }
  handleResponse(): any {
    return {
      next: (res) => {
        this.InsertDrExamination();
      },
      error: (err) => { },
    };
  }
  handleResponse1(): any {
    return {
      next: (res) => {
        this.saveNursingData();
      },
      error: (err) => { },
    };
  }
  
  CurrentPatient(val) {
    if (val == 0) {
      this.admssionById = "Y";
    } else {
      this.admssionById = "A";
    }
  }

  filterpoponedfunction(name: string) {
    const len = Object.keys(name).length;
    if (len > 9) {
      return this.getpospondArray.filter(
        (country) => country.status?.toLowerCase().indexOf(name) === 0
      );
    } else {
      return this.getpospondArray.filter(
        (country) =>
          country.status?.toLowerCase().indexOf(name?.toLowerCase()) === 0
      );
    }
  }

  newipddoctorId: number = 0;
  newipdrName: string = null;
  getdoctorobj2(e: any) {
    var val = e.option.value;
    this.newipdrName = val.userName;
    this.newipddoctorId = val.userId;
  }
  getdoctorobj1(e: any) {
    var val = e.option.value;
    this.dischargeDatamodel.drName = val.userName;
    this.dischargeDatamodel.fK_DoctorId = val.userId;
  }



// get IPD Medicine
getIPDPrescptionArray: IpdvisitPrescModel[] = [];
getIPDPrescptionDeleteArray: IpdvisitPrescModel[] = [];
getIPDPreceptionDetail(examvisitid, ipdid) {
  this.getIPDPrescptionDeleteArray = [];
  this.ipdService.getIpdPresception(examvisitid, ipdid).pipe(takeUntil(this.destroyipd$)).subscribe(
    (x: any) => {
      this.getIPDPrescptionArray = [];
      this.getIPDPrescptionArray = x;
      this.getIPDPrescptionArray.map(
        (item) => (item.checkprescpedit = false)
      );
    },
    (err) => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    }
  );
}
// get IPD investigation
getIPDInvestigationArray: IpdvisitInvestModel[] = [];
getIPDInvestigationDeleteArray: IpdvisitInvestModel[] = [];
getIpdvisitInvestDetail(examvisitid, ipdid) {
  this.getIPDInvestigationDeleteArray = [];
  this.ipdService.getIpdvisitInvest(examvisitid, ipdid).pipe(takeUntil(this.destroyipd$)).subscribe(
    (x: any) => {
      this.getIPDInvestigationArray = [];
      this.getIPDInvestigationArray = x;
      this.getIPDInvestigationArray.map(
        (item) => (item.checkInvetedit = false)
      );
    },
    (err) => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    }
  );
}
// get IPD Diagonsis
getIPDDiagonosisArray: IpdvisitDiagnosisModel[] = [];
getIPDDiagonosisDeleteArray: IpdvisitDiagnosisModel[] = [];
getIpdvisitDaigonsisDetail(examvisitid, ipdid) {
  this.getIPDDiagonosisDeleteArray = [];
  this.ipdService.getIpdvisitDaigonsis(examvisitid, ipdid).pipe(takeUntil(this.destroyipd$)).subscribe(
    (x: any) => {
      this.getIPDDiagonosisArray = [];
      this.getIPDDiagonosisArray = x;
      this.getIPDDiagonosisArray.map((item) => (item.checkDiagnosis = false));
    },
    (err) => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    }
  );
}

// get IPD examination finding
getIPDExaminationArray: IpdvisitExamModel[] = [];
getIPDExaminationDeleteArray: IpdvisitExamModel[] = [];
getIpdvisitExaminationDetail(examvisitid, ipdid) {
  this.getIPDExaminationDeleteArray = [];
  this.ipdService.getIpdvisitExamination(examvisitid, ipdid).pipe(takeUntil(this.destroyipd$)).subscribe(
    (x: any) => {
      this.getIPDExaminationArray = [];
      this.getIPDExaminationArray = x;
      this.getIPDExaminationArray.map((item) => (item.checkUpdate = false));
    },
    (err) => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    }
  );
}




    // get ipd examination list by doctor
    getIPDExamListArray: getIPDExamList[] = [];
    getipdExamlistObj: getIPDExamList = {};
    getipdExamlistByIpdId(examvisitid, ipdid) {
      this.ipdService.getExaminationList(examvisitid, ipdid).pipe(takeUntil(this.destroyipd$)).subscribe(
        (x: any) => {
          this.getipdExamlistObj = {};
          this.getIPDExamListArray = [];
  
          this.getIPDExamListArray = x.reverse();
  
          if (this.getIPDExamListArray.length > 0) {
            this.rowClickedipdDoctor = 0;
            this.getipdExamlistObj = this.getIPDExamListArray[0];
  
            this.newipdrName = this.getipdExamlistObj.drName;
            this.newipddoctorId = this.getipdExamlistObj.fK_DoctorID;
            this.DoctorCtrl2.patchValue(this.newipdrName);
            // this._filter2( this.newipdrName);
  
            this.getIPDPreceptionDetail(
              this.getipdExamlistObj.pK_IPDVisitID,
              this.selectIpdId
            );
            this.getIpdvisitInvestDetail(
              this.getipdExamlistObj.pK_IPDVisitID,
              this.selectIpdId
            );
            this.getIpdvisitDaigonsisDetail(
              this.getipdExamlistObj.pK_IPDVisitID,
              this.selectIpdId
            );
            this.getIpdvisitExaminationDetail(
              this.getipdExamlistObj.pK_IPDVisitID,
              this.selectIpdId
            );
          } else {
            this.rowClickedipdDoctor = -1;
            this.getIPDPrescptionArray = [];
            this.getIPDPrescptionDeleteArray = [];
            this.getIPDInvestigationArray = [];
            this.getIPDInvestigationDeleteArray = [];
            this.getIPDExaminationDeleteArray = [];
            this.getIPDExaminationArray = [];
            this.getIPDDiagonosisArray = [];
            this.getIPDDiagonosisDeleteArray = [];
            if (this.authService.Loggeduser.usertypeid == 6) {
              this.newipdrName = this.authService.Loggeduser.firstname;
              this.newipddoctorId = this.authService.Loggeduser.userid;
              this.DoctorCtrl2.patchValue(this.newipdrName);
              this.DoctorCtrl2.disable();
            } else {
              this.newipdrName = null;
              this.newipddoctorId = 0;
            }
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          } 
          else if(err.error.statusCode == 422){
            this.dashboardService.openSnackBar(err.error.message,"OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
    }
  InsertDrExamination() {
    if (
      this.getipdExamlistObj.fK_DoctorID == null ||
      this.getipdExamlistObj.fK_DoctorID == undefined
    ) {
      this.showspinner1 = false;
      return this.dashboardService.openSnackBar("Please Select Doctor", "OK");
    }
    if (
      this.getipdExamlistObj.examType == null ||
      this.getipdExamlistObj.examType == undefined
    ) {
      this.showspinner1 = false;
      return this.dashboardService.openSnackBar("Please Select ExamType", "OK");
    }
    this.showspinner1 = true;
    let payload = {
      IpdExaminationMaster: {
        PK_IPDVisitID: this.getipdExamlistObj.pK_IPDVisitID
          ? this.getipdExamlistObj.pK_IPDVisitID
          : 0,
        FK_IPDID: this.selectIpdId,
        VisitDate:
          this.getipdExamlistObj.pK_IPDVisitID > 0
            ? this.getipdExamlistObj.visitDate
            : this.datePipe.transform(new Date(), "yyyy-MM-dd HH:mm:ss"),
        FK_DoctorID: this.getipdExamlistObj.fK_DoctorID,
        DoctorAdvise: this.getipdExamlistObj.doctorAdvise,
        ExaminationComments: this.getipdExamlistObj.examinationComments,
        ExamType: this.getipdExamlistObj.examType,
        IsEdit: this.getipdExamlistObj.pK_IPDVisitID > 0 ? true : false,
        IsDelete: false,
      },
      IpdVisitExaminationDetail: this.getIPDExaminationArray.concat(
        this.getIPDExaminationDeleteArray
      ),
      IpdVisitInvestigationDetail: this.getIPDInvestigationArray.concat(
        this.getIPDInvestigationDeleteArray
      ),
      IpdVisitDiagnosisDetail: this.getIPDDiagonosisArray.concat(
        this.getIPDDiagonosisDeleteArray
      ),
      IpdVisitPrescriptionDetail: this.getIPDPrescptionArray.concat(
        this.getIPDPrescptionDeleteArray
      ),
    };
    this.ipdService.insertIPDDrExamination(payload).pipe(takeUntil(this.destroyipd$)).subscribe(
      (x) => {
        this.getipdExamlistObj.pK_IPDVisitID = x["id"];
        this.newdoctorenablebtn = false;
        this.showspinner1 = false;

        this.getipdExamlistByIpdId(0, this.selectIpdId);
        this.dashboardService.openSnackBar("Record Saved Successfully", "OK");
      },
      (err) => {
        this.showspinner1 = false;
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      }
    );
  }

   GetRateType() {
    this.billingservice.get_rate_typelist().pipe(takeUntil(this.destroyipd$)).subscribe((data: any[]) => {
      this.billingservice.ratetype = data;
      // console.log('billingservice.ratetype',data)
    },err =>{
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }
  PosponedControll() {
    this.OperenedCtrl = new FormControl();
    this.filteredOperenedArray = this.OperenedCtrl.valueChanges.pipe(
      startWith(""),
      map((cat) =>
        cat ? this.filterpoponedfunction(cat) : this.getpospondArray.slice()
      )
    );
  }
  roomCategoryController() {
    this.RoomCategory = new FormControl();
    this.filteredRoomArray = this.RoomCategory.valueChanges.pipe(
      startWith(""),
      map((cat) =>
        cat ? this.filterroomfunction(cat) : this.categoryRoomArray.slice()
      )
    );
  }
  filterroomfunction(name: string) {
    return this.categoryRoomArray.filter(
      (country) =>
        country.roomCategory.toLowerCase().indexOf(name.toLowerCase()) === 0
    );
  }

//get schedule type
getDoctorBrach() {
  this.dashboardService.getall_doctors().pipe(takeUntil(this.destroyipd$)).subscribe(
    (data) => this.success_doctors(data),
    (err) => this.failed_doctors(err)
  );
}

success_doctors(data) {
  if (this.authService.masterdata.isExternal === true) {
    this.opdvisitService.doctors = data.filter(
      (item) => item.isExternal == false
    );
    this.doctorControll();
  } else {
    this.opdvisitService.doctors = data;
    this.doctorControll();
  }
}
failed_doctors(err) {
  if (err.status == 403) {
    this.dashboardService.openSnackBar("You Don't have Permission", "OK");
  } 
  else if(err.error.statusCode == 422){
    this.dashboardService.openSnackBar(err.error.message,"OK");
  }
  else {
    this.dashboardService.openSnackBar("API Failed", "OK");
  }
}

//room category
categoryRoomArray: any = [];
getRoomCategoryMaster() {
  this.ipdService.getRoomCategoryMaster(this.authService.Loggeduser.specialityId).pipe(takeUntil(this.destroyipd$)).subscribe((x: any) => {
    this.categoryRoomArray = [];
    this.categoryRoomArray = x.filter((item) => item.isActive == true);
    this.roomCategoryController();
  }, err => {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  });
}

  GetPostponedData() {
    this.getpospondArray = [];
    try {
      this.ipdService.GetPostponed().pipe(takeUntil(this.destroyipd$)).subscribe((item) => {
        this.getpospondArray = item;
        this.PosponedControll();
      }, err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });
    } catch (e) { }
  }

  formatAmountfun() {
    this.ipdService.GetpackagebyIpdId(this.selectIpdId).pipe(takeUntil(this.destroyipd$)).subscribe((data) => {
      this.OTpackageName = data.map((obj) => obj.packageName).join(",");

      const totalAmount = data.reduce((sum, item) => sum + item.amount, 0);
      this.ipdAmount = totalAmount;
    },err =>{
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }
  dateChanged(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const newDate = inputElement.value;
    this.getotcasesheetData(0, newDate);
  }
  getotcasesheetData(type: number, datechange?: any) {
    this.opdvisitService.getpatientdetails(this.RegId);
    this.formatAmountfun();

    const applicationdata = this.opdvisitService.documentrul.filter(
      (item) => item.propertyName == "WithoutOTRegistraionOTSheetShow"
    );

    if (applicationdata[0]?.propertyValue == "Y") {
      this.ipdService.GetOtRegisterByRegId(this.RegId).pipe(takeUntil(this.destroyipd$)).subscribe(
        (x: any) => {
          this.getotRegdata = x;

          if (this.getotRegdata.length > 0) {
            if (type == 0) {
              var surgerydate = datechange;
              // this.OtcaseSheetobj.pK_RegId = 0;
            } else {
              var surgerydate =
                this.getotRegdata[this.currentIndex].surgeryDate;
              this.OtcaseSheetobj.startTime =
                this.getotRegdata[this.currentIndex].startTime;
              this.OtcaseSheetobj.finishTime =
                this.getotRegdata[this.currentIndex].finishTime;
            }

            this.ipdService
              .GetOtRecordBySurgeryDateByRegIdByIPDIdByBranchId(
                surgerydate,
                this.RegId,
                this.selectIpdId,
                this.authService.Loggeduser.branchid
              ).pipe(takeUntil(this.destroyipd$))
              .subscribe((x: any) => {
                this.OtcaseSheetobj = {};
                this.OtcaseSheetArray = [];
                this.OtcaseSheetobj.surgeryDate = surgerydate;
                if (x.length > 0) {
                  this.OtcaseSheetArray = x;
                  this.OtcaseSheetobj = x[this.currentIndex];
                  this.OtcaseSheetobj.surgeryDate = this.datePipe.transform(
                    x[this.currentIndex].surgeryDate,
                    "yyyy-MM-dd"
                  );
                  this.OtcaseSheetobj.site = x[this.currentIndex].site;
                  this.OtcaseSheetobj.startTime =
                    x[this.currentIndex].startTime;
                  this.OtcaseSheetobj.finishTime =
                    x[this.currentIndex].finishTime;
                }
                // this.OtcaseSheetobj.pK_RegId = this.RegId;
                if (this.OtcaseSheetobj.netBillAmt == null) {
                  this.OtcaseSheetobj.netBillAmt = 0;
                }
                this.calldrugALlergeryData();
              });
          } else {
            if (type == 0) {
              var surgerydate = datechange;
              // this.OtcaseSheetobj.pK_RegId = 0;
            } else {
              var surgerydate = this.admissionTo;
            }
            this.getCallbyBranchid(surgerydate);
          }
        },
        (err) => { 
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          } 
          else if(err.error.statusCode == 422){
            this.dashboardService.openSnackBar(err.error.message,"OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
    } else {
      if (type == 0) {
        var surgerydate = datechange;
        // this.OtcaseSheetobj.pK_RegId = 0;
      } else {
        var surgerydate = this.admissionTo;
      }
      this.getCallbyBranchid(surgerydate);
    }

    this.GetOtIolPowerDetailByIPDId();
    this.GetIOLBookingListByConsID();
  }

  GetIOLBookingListByConsID() {
    this.ipdService.GetIOLBookingListByConsID(this.consId).pipe(takeUntil(this.destroyipd$)).subscribe(
      (x: any) => {
        // console.log(x);
        if (x.length > 0) {
          this.IOLBookingData = x;
        }
      },
      (err) => { 
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      }
    );
  }
  GetOtIolPowerDetailByIPDId() {
    this.ipdService.GetOtIolPowerDetailByIPDId(this.selectIpdId).pipe(takeUntil(this.destroyipd$)).subscribe(
      (x: any) => {
        if (x.length > 0) {
          this.IOLgetData = x[0];
        }
        // console.log(this.IOLgetData);
      },
      (err) => { 
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      }
    );
  }

  getCallbyBranchid(addmintiondate) {
    this.ipdService
      .GetOtRecordByIPDAdmDateByRegIdByIPDId(
        addmintiondate,
        this.RegId,
        this.selectIpdId
      ).pipe(takeUntil(this.destroyipd$))
      .subscribe((x: any) => {
        this.OtcaseSheetobj = {};
        this.OtcaseSheetArray = [];
        if (x.length > 0) {
          this.OtcaseSheetArray = x;
          this.OtcaseSheetobj = x[this.currentIndex];
          if (x[this.currentIndex].surgeryDate != null) {
            this.OtcaseSheetobj.surgeryDate = this.datePipe.transform(
              x[this.currentIndex].surgeryDate,
              "yyyy-MM-dd"
            );
          } else {
            this.OtcaseSheetobj.surgeryDate = addmintiondate;
          }
          this.OtcaseSheetobj.site = x[this.currentIndex].site;
          this.OtcaseSheetobj.startTime = x[this.currentIndex].startTime;
          this.OtcaseSheetobj.finishTime = x[this.currentIndex].finishTime;
        }
        // this.OtcaseSheetobj.pK_RegId = this.RegId;
        if (this.OtcaseSheetobj.netBillAmt == null) {
          this.OtcaseSheetobj.netBillAmt = 0;
        }
        this.calldrugALlergeryData();
      },err =>{
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });
  }
  calldrugALlergeryData() {
    this.ipdService.get_pasthistory(this.RegId).pipe(takeUntil(this.destroyipd$)).subscribe(
      (x: any) => {
        if (x.length > 0) {
          this.OtcaseSheetobj.sysDisease = x
            .map((x1) => x1.diseaseName)
            .join(",");
        }
      },
      (err) => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      }
    );
    this.ipdService.get_allergies(this.RegId).pipe(takeUntil(this.destroyipd$)).subscribe(
      (x: any) => {
        if (x.length > 0) {
          this.OtcaseSheetobj.DrugAllergy = x
            .map((x1) => x1.saltName)
            .join(",");
        }
      },
      (err) => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      }
    );
  }
  start(type) {
    if (type == 1) {
      this.surgicalRecordobj.pK_OTId =
        this.getotRegdata[this.currentIndex].pK_OTId;
      (this.surgicalRecordobj.fK_IPDId =
        this.getotRegdata[this.currentIndex].fK_IPDId),
        (this.surgicalRecordobj.startTime = moment(
          this.authService.localDate
        ).format("hh:mm:ss"));
      this.surgicalRecordobj.isEdit = true;
      this.surgicalRecordobj.headName = "START";
      let payload = {
        OtRegister: this.surgicalRecordobj,

        OtRecordSurgery: [],
        OtIolPowerDetail: {},
      };
      this.ipdService.InsertOtRegister(payload).pipe(takeUntil(this.destroyipd$)).subscribe(
        (x: any) => {
          this.showspinner1 = false;
          this.dashboardService.openSnackBar("Started", "OK");
          this.getotcasesheetData(1);
        },
        (err) => {
          this.showspinner1 = false;
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          } 
          else if(err.error.statusCode == 422){
            this.dashboardService.openSnackBar(err.error.message,"OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
    } else {
      this.surgicalRecordobj.pK_OTId =
        this.getotRegdata[this.currentIndex].pK_OTId;
      (this.surgicalRecordobj.fK_IPDId =
        this.getotRegdata[this.currentIndex].fK_IPDId),
        (this.surgicalRecordobj.finishTime = moment(
          this.authService.localDate
        ).format("hh:mm:ss"));
      this.surgicalRecordobj.isEdit = true;
      this.surgicalRecordobj.headName = "FINISH";
      let payload = {
        OtRegister: this.surgicalRecordobj,

        OtRecordSurgery: [],
        OtIolPowerDetail: {},
      };
      this.ipdService.InsertOtRegister(payload).pipe(takeUntil(this.destroyipd$)).subscribe(
        (x: any) => {
          this.showspinner1 = false;
          this.dashboardService.openSnackBar("Finished", "OK");
          this.getotcasesheetData(1);
        },
        (err) => {
          this.showspinner1 = false;
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          } 
          else if(err.error.statusCode == 422){
            this.dashboardService.openSnackBar(err.error.message,"OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
    }
  }

//get not yet reported

GetNotYetReported() {
  this.TotalNotyetReported = 0;
  let BranchId = this.authService.Loggeduser.branchid;
  try {
    this.ipdService.NotyetReported(BranchId).pipe(takeUntil(this.destroyipd$)).subscribe((item) => {
      this.TotalNotyetReported = item;
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  } catch (e) { }
}

  getAnesthesiaMasterList() {
    this.ipdService.getAnesthesiaMaster().pipe(takeUntil(this.destroyipd$)).subscribe((data) => {
      this.dataSource.data = data;
      this.masterData = data;
      if (this.prerecordlength == 0) {
        this.masterData = data;
        this.addPreList();
      }
    },err =>{
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }

  
  getSite() {
    this.emrservice.getMasterSite().pipe(takeUntil(this.destroyipd$)).subscribe((data) => {
      this.sitelist = [];
      this.sitelist = data;
    },err =>{
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }
  addPreList() {
    this.masterDataList = [];
    this.masterData.forEach((element) => {
      this.masterDataList.push({
        actualValue: element.defaultValues,
        fK_IPDID: this.selectIpdId,
        headName: element.headName,
        isEdit: false,
        isHeader: element.isHeader,
        isHidden: element.isHidden,
        pK_SynchId: element.pK_SynchId,
        pK_TranId: 0,
      });
    });
    this.dataSourceWorkup.data = this.masterDataList;
    this.patIpdlist = this.masterDataList;
  }
  GetLocationData() {
    this.getipdLocation = [];
    try {
      this.ipdService.getIpdLocation(0).pipe(takeUntil(this.destroyipd$)).subscribe((item) => {
        this.getipdLocation = item;
      }, err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });
    } catch (e) {

    }
  }
  GetotData() {
    this.getOTArray = [];
    let BranchId = this.authService.Loggeduser.branchid;
    try {
      this.ipdService.GetOTData(BranchId).pipe(takeUntil(this.destroyipd$)).subscribe((item) => {
        this.getOTArray = item.filter((x) => x.isActive == true);
        this.OtGroupControll();
      }, err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });
    } catch (e) { }
  }
  OtGroupControll() {
    this.OtgroupCtrl = new FormControl();
    this.filteredOtGroupArray = this.OtgroupCtrl.valueChanges.pipe(
      startWith(""),
      map((cat) => (cat ? this.filterOtfunction(cat) : this.getOTArray.slice()))
    );
  }

  //Get Opertation Type
  GetotTypeData() {
    this.getOPTypeArray = [];
    try {
      this.ipdService.GetOPType().pipe(takeUntil(this.destroyipd$)).subscribe((item) => {
        this.getOPTypeArray = item;
        this.OpTypeControll();
      }, err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });
    } catch (e) { }
  }
  // Get Ot Theatre

  GetOtTheatreData() {
    this.getOtTheatreArray = [];
    let BranchId = this.authService.Loggeduser.branchid;
    try {
      this.ipdService.GetOtTheatre(BranchId).pipe(takeUntil(this.destroyipd$)).subscribe((item) => {
        this.getOtTheatreArray = item.filter((x) => x.isActive == true);
        this.OTThreateControll();
      }, err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });
    } catch (e) { }
  }
  doctorControll() {
    this.DoctorCtrl = new FormControl();
    this.filteredDoctorArray = this.DoctorCtrl.valueChanges.pipe(
      startWith(""),
      map((cat) =>
        cat
          ? this.filterdoctorfunction(cat)
          : this.opdvisitService.doctors.slice()
      )
    );
  }
  getOpTypeobj1(e: any) {
    var val = e.option.value;
    // this.opTypeName = val.operationTypeName;
    this.surgicalRecordobj.fK_OperationTypeId = val.pK_OperationTypeId;
    this.surgicalRecordobj.operationTypeName = val.operationTypeName;
  }

  filterdoctorfunction(name: string) {
    const len = Object.keys(name).length;
    if (len > 9) {
      return this.opdvisitService.doctors.filter(
        (country) => country.userName?.toLowerCase().indexOf(name) === 0
      );
    } else {
      return this.opdvisitService.doctors.filter(
        (country) =>
          country.userName?.toLowerCase().indexOf(name?.toLowerCase()) === 0
      );
    }
  }
  selectedTabValue(event) {
    this.selectedTabIndex = event.index;
    this.labelName = event.tab.textLabel;
    // if(this.labelName == "Corporate Detail"){
    //   this.addCorporateDetail();
    // }
    // if (this.labelName == "Pre-Anae Question") {
    //   this.getByIPdList(this.selectIpdId);
    // }
    // else if (this.labelName == "Pre-Op Checklist") {
    //   this.getPreOpListIpdId(this.selectIpdId);
    // }
    //this.getByIPdList(this.selectIpdId);
    // this.getPreOpListIpdId(this.selectIpdId);
    if (this.labelName == "GA Checklist") {
      //   this.getGACheckListIpdId(this.selectIpdId);
    } else if (this.labelName == "Pre-op Checklist") {
      this.getPreOpCheckListMaster();
    }

    // this.GetDischargeData(this.selectIpdId);

    // this.getOtConsent(this.selectIpdId);
   
  }
  getPreOpCheckListMaster() {
    this.ipdService.getPreOpListMaster().pipe(takeUntil(this.destroyipd$)).subscribe((data) => {
      this.masterListData = [];
      // this.dataSource.data = data;
      this.masterListData = data;
      // this.PreOpListControll();
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }

 

 
  getOTTheatreobj1(e: any) {
    var val = e.option.value;
    // console.log(val);
    this.surgicalRecordobj.theatreName = val.theatreName;
    this.surgicalRecordobj.fK_TheatherId = val.pK_OTTheatreId;
  }

  opendiagnosisdata(): void {
    const dialogRef = this.dialog.open(DiagnosisComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "90vw",
      width: "70%",
      disableClose: true,
    });
    dialogRef.afterClosed().pipe(takeUntil(this.destroyipd$)).subscribe((result) => {
      if (result.length > 0) {
        var newdaigonsis = [];
        result?.forEach((item) => {
          newdaigonsis.push(item.diagnosisName);
        });
        if (
          this.surgicalRecordobj.diagnosis != null &&
          this.surgicalRecordobj.diagnosis != ""
        ) {
          this.surgicalRecordobj.diagnosis =
            this.surgicalRecordobj.diagnosis +
            "\r\n" +
            newdaigonsis.join("\r\n");
        } else {
          this.surgicalRecordobj.diagnosis = newdaigonsis.join("\r\n");
        }
      }
    });
  }
  getSurgerydoctorobj(e: any, type) {
    var val = e.option.value;
    if (type == 1) {
      this.surgicalRecordobj.fellowsDoctor = val.userName;
      // this.consultantId = val.userId;
    } else if (type == 2) {
      this.surgicalRecordobj.anaesthetistName = val.userName;
      this.surgicalRecordobj.fK_AnaesthetistId = val.userId;
    } else if (type == 3) {
      this.surgicalRecordobj.surgeonName = val.userName;
      this.surgicalRecordobj.fK_SurgenId = val.userId;
    } else if (type == 4) {
      this.surgicalRecordobj.cosurgeonName = val.userName;
      this.surgicalRecordobj.fK_CoSurgeonId = val.userId;
    } else if (type == 5) {
      this.PreopAssesmentRecordModelobj.anesthetist = val.userName;
      this.PreopAssesmentRecordModelobj.fK_AnesthetistId = val.userId;
    } else if (type == 6) {
      this.AnestheticRecordModelobj.doctor = val.userName;
      this.AnestheticRecordModelobj.fK_DoctorID = val.userId;
    }
  }
  CheckinputSurgery(event: any, type) {
    var checkdata = event.target.value;
    if (checkdata == "" && type == 1) {
      this.doctorControll();
      this.surgicalRecordobj.fellowsDoctor = event.target.value
        ? event.target.value
        : null;
    } else if (checkdata == "" && type == 2) {
      this.doctorControll();
      this.surgicalRecordobj.anaesthetistName = null;
      this.surgicalRecordobj.fK_AnaesthetistId = null;
    } else if (checkdata == "" && type == 3) {
      this.doctorControll();
      this.surgicalRecordobj.surgeonName = null;
      this.surgicalRecordobj.fK_SurgenId = null;
    } else if (checkdata == "" && type == 4) {
      this.doctorControll();
      this.surgicalRecordobj.cosurgeonName = null;
      this.surgicalRecordobj.fK_CoSurgeonId = null;
    } else if (checkdata == "" && type == 5) {
      this.PreopAssesmentRecordModelobj.anesthetist = null;
      this.PreopAssesmentRecordModelobj.fK_AnesthetistId = null;
    } else if (checkdata == "" && type == 6) {
      this.AnestheticRecordModelobj.doctor = null;
      this.AnestheticRecordModelobj.fK_DoctorID = null;
    }
  }

  OpTypeControll() {
    this.OpTypeCtrl = new FormControl();
    this.filteredOpTypeArray = this.OpTypeCtrl.valueChanges.pipe(
      startWith(""),
      map((cat) =>
        cat ? this.filterOpfunction(cat) : this.getOPTypeArray.slice()
      )
    );
    // console.log(this.filteredOpTypeArray,'called data')
  }

  filterOpfunction(name: string) {
    const len = Object.keys(name).length;
    if (len > 9) {
      return this.getOPTypeArray.filter(
        (country) =>
          country.operationTypeName?.toLowerCase().indexOf(name) === 0
      );
    } else {
      return this.getOPTypeArray.filter(
        (country) =>
          country.operationTypeName
            ?.toLowerCase()
            .indexOf(name?.toLowerCase()) === 0
      );
    }
  }

  getOpTypeobj(e: any) {
    var val = e.option.value;
    this.opTypeName = val.operationTypeName;
    this.opTypeId = val.pK_OperationTypeId;
  }
  CheckinputOpType(event: any) {
    var checkdata = event.target.value;
    if (checkdata == "") {
      this.OpTypeControll();
      this.opTypeId = 0;
    }
  }
  
  sugeryStatusArray: any = [];
  GetsurgeryStausIddata() {
    this.ipdService.GetsurgeryStausId().pipe(takeUntil(this.destroyipd$)).subscribe((item: any) => {
      this.sugeryStatusArray = [];
      this.sugeryStatusArray = item;
    },err =>{
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }
  refhelplistPOpup(type, value) {
    const dialogRef = this.dialog.open(HelpListPopupComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "50vw",
      disableClose: true,
      width: "35%",
      data: {
        typeid: type,
      },
    });
    dialogRef.afterClosed().pipe(takeUntil(this.destroyipd$)).subscribe((result) => {
      if (result != null && result != undefined && result != 0) {
        if (value == 1) {
          this.dischargeDatamodel.gPrad = result;
        } else if (value == 2) {
          this.dischargeDatamodel.gPran = result;
        } else if (value == 3) {
          this.dischargeDatamodel.gPraI = result;
        } else if (value == 4) {
          this.dischargeDatamodel.gPlad = result;
        } else if (value == 5) {
          this.dischargeDatamodel.gPlan = result;
        } else if (value == 6) {
          this.dischargeDatamodel.gPlaI = result;
        } else if (value == 7) {
          this.surgicalRecordobj.duration = result;
        } else if (value == 8) {
          this.surgicalRecordobj.surgeryStatus = result;
          this.surgicalRecordobj.fK_OTStatusId = this.sugeryStatusArray.filter(
            (item) =>
              item.popupDescription.toLocaleLowerCase() ==
              result.toLocaleLowerCase()
          )[0].pkPopupId;
        }
      }
    });
  }


  Addnewsurgery() {
    const dialogRef = this.dialog.open(CommanSurgeryPopupComponent, {
      width: "60%",
      data: {},
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroyipd$)).subscribe((result) => {
      if (result.length > 0) {
        result.forEach((item) => {
          this.getotsurgeryArray.push({
            pK_OTSurgeryDetailId: 0,
            fK_OTId: 0,
            fK_SurgeryId: item.pkSurgeryId,
            fK_SurgeonId: this.surgicalRecordobj.fK_SurgenId,
            remarks: item.eye,
            fK_QualifierId: null,
            oldotid: null,
            isEdit: false,
            isHidden: false,
            surgeryName: item.surgeryName,
            qualifierName: null,
            surgeon: this.surgicalRecordobj.surgeonName,
            site: item.eye,
            rightEyeSurgerycount: null,
            leftEyeSurgerycount: null,
            diagnosis: null,
          });
        });
      }
    });
  }
// get OT surgery
getotsurgeryArray: OtRecordSurgeryModel[] = [];
GetOtSurgeryByOTId(pK_OTId) {
  this.ipdService.GetOtRecordSurgeryByOTId(pK_OTId).pipe(takeUntil(this.destroyipd$)).subscribe(
    (x: any) => {
      this.getotsurgeryArray = [];
      this.getotsurgeryArray = x;
    },
    (err) => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    }
  );
}

GetColor(color: any) {
  var colorcode = Number(color).toString(16);
  if (colorcode == "ff") {
    colorcode = "ff0000";
  } else if (colorcode == "ff00") {
    colorcode = "00ff00";
  } else if (colorcode == "ffff") {
    colorcode = "ffff00";
  }

  return "#" + colorcode;
  // const hexcode ='#00' + parseInt(colorcode).toString(16).toUpperCase();
  // return hexcode;
}
getColor(): string {
  return this.color;
}


shouldDisableDecrement(inputValue: number): boolean {
  return !this._wrap && inputValue <= this._min;
}

shouldDisableIncrement(inputValue: number): boolean {
  return !this._wrap && inputValue >= this._max;
}

hourshouldDisableDecrement(hourinputValue: number): boolean {
  return !this._wrap && hourinputValue <= this._min;
}

hourshouldDisableIncrement(hourinputValue: number): boolean {
  return !this._wrap && hourinputValue >= this._hourmax;
}

changeFormat(event: any) {
  this.timeFormatcheck = event;
}
private ChangetimeName: any;
//Discharge Time
newindex: number = -1;
checknursemedTranid: number = 0;
admissionTime(type: any, index?: number, cehcid?: number) {
  this.ChangetimeName = type;
  this.timeFormatArray = [];
  this._value = 0;
  this._hourvalue = 0;
  this.newindex = index;
  this.checknursemedTranid = cehcid;
  document.getElementById("admissionTimeModal").style.display = "block";
}
CanceladmissionTime() {
  document.getElementById("admissionTimeModal").style.display = "none";
}
color: any;
  _value: number = 0;
  _hourvalue: number = 0;
  _step: number = 1;
  _min: number = 0;
  _max: number = 60;
  _hourmax: number = 12;
  _wrap: boolean = false;


  
  CheckinputOTTheatre1(event: any) {
    var checkdata = event.target.value;
    if (checkdata == "") {
      this.OTThreateControll();
      this.surgicalRecordobj.theatreName = null;
      this.surgicalRecordobj.fK_TheatherId = null;
    }
  }
  filterOtfunction(name: string) {
    const len = Object.keys(name).length;
    if (len > 9) {
      return this.getOTArray.filter(
        (country) => country.groupName?.toLowerCase().indexOf(name) === 0
      );
    } else {
      return this.getOTArray.filter(
        (country) =>
          country.groupName?.toLowerCase().indexOf(name?.toLowerCase()) === 0
      );
    }
  }
  filterOTfunction(name: string) {
    const len = Object.keys(name).length;
    if (len > 9) {
      return this.getOtTheatreArray.filter(
        (country) => country.theatreName?.toLowerCase().indexOf(name) === 0
      );
    } else {
      return this.getOtTheatreArray.filter(
        (country) =>
          country.theatreName?.toLowerCase().indexOf(name?.toLowerCase()) === 0
      );
    }
  }
  OTThreateControll() {
    this.OTTheatreCtrl = new FormControl();
    this.filteredOTTheatreArray = this.OTTheatreCtrl.valueChanges.pipe(
      startWith(""),
      map((cat) => cat ? this.filterOTfunction(cat) : this.getOtTheatreArray.slice()
      )
    );
  }
 
// add time
timeFormatArray: any = [];
addTime(hr, min) {
  if (hr > 12 || min > 59 || min == null || hr == null) {
    return this.dashboardService.openSnackBar("Select Valid Time", "OK");
  } else if (hr < 1 || min < 0) {
    return this.dashboardService.openSnackBar("Select Valid Time", "OK");
  }
  let bindtime = hr + ":" + min + " " + this.timeFormatcheck;
  // this.timeFormatArray.push({
  //   "dosageTime": bindtime
  // });
  if (this.ChangetimeName == 1) {
    this.getipddischargeData[0].ipdAdmTime = bindtime;
  } else if (this.ChangetimeName == 2) {
    this.getipddischargeData[0].surgeryTime = bindtime;
  } else if (this.ChangetimeName == 3) {
    this.getipddischargeData[0].tod = bindtime;
  } else if (this.ChangetimeName == 4) {
    this.dischargeDatamodel.firstFollowupTime = bindtime;
  } else if (this.ChangetimeName == 5) {
    this.dischargeDatamodel.secondFollowupTime = bindtime;
  } else if (this.ChangetimeName == 6) {
    this.GetNursingChartArray[this.newindex].mTime =
      this.datePipe.transform(new Date(), "yyyy-MM-dd") +
      " " +
      moment(bindtime, "hh:mm A").format("HH:mm");
    this.GetNursingChartArray[this.newindex].isEdit =
      this.checknursemedTranid > 0 ? true : false;
    this.GetNursingChartArray[this.newindex].isDelete = false;
  } else if (this.ChangetimeName == 7) {
    this.surgicalRecordobj.surgeryTime = bindtime;
  } else if (this.ChangetimeName == 8) {
    this.surgicalRecordobj.initiatedTime = bindtime;
  } else if (this.ChangetimeName == 9) {
    this.surgicalRecordobj.timedOut = bindtime;
  } else if (this.ChangetimeName == 10) {
    this.selectedRoutineExam.entryDatetime = bindtime;
    this.selecttime = bindtime;
  } else if (this.ChangetimeName == 11) {
    this.AnestheticRecordModelobj.nilOrallyTime = bindtime;
  } else if (this.ChangetimeName == 12) {
    this.AnestheticVisitDetailModeldata[this.newindex].nTime =
      this.datePipe.transform(new Date(), "yyyy-MM-dd") +
      " " +
      moment(bindtime, "hh:mm A").format("HH:mm");
    this.AnestheticVisitDetailModeldata[this.newindex].isEdit =
      this.checknursemedTranid > 0 ? true : false;
  }
  this.CanceladmissionTime();
}
GetNursingChartArray: GetNursingChartModel[] = [];
  GetNursingChartdata() {
    this.ipdService.GetNursingChart(this.selectIpdId).pipe(takeUntil(this.destroyipd$)).subscribe(
      (x: any) => {
        this.GetNursingChartArray = [];
        if (x.length > 0) {
          this.GetNursingChartArray = x;
        }
      },
      (err) => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      }
    );
  }

  PreopAssesmentRecordindication: boolean = false;
  AnestheticRecordModelobj: AnestheticRecordModel = {};
  GetAnestheticRecordByIPDId(ipdid) {
    this.ipdService.GetAnestheticRecordByIPDId(ipdid).pipe(takeUntil(this.destroyipd$)).subscribe(
      (item: any) => {
        this.AnestheticRecordModelobj = {};
        if (item.length > 0) {
          this.AnestheticRecordModelobj = item[0];
          this.AnestheticRecordModelobj.isEdit = true;
          this.PreopAssesmentRecordindication = true;
          if (
            this.AnestheticRecordModelobj.nilOrallyTime != null &&
            this.AnestheticRecordModelobj.nilOrallyTime != "00:00:00"
          ) {
            this.AnestheticRecordModelobj.nilOrallyTime = moment(
              this.AnestheticRecordModelobj.nilOrallyTime,
              ["HH:mm"]
            ).format("h:mm A");
          } else {
            this.AnestheticRecordModelobj.nilOrallyTime = moment(
              this.authService.localDate
            ).format("h:mm A");
          }
          this.AnestheticRecordModelobj.nilOrallyDt = this.datePipe.transform(
            this.AnestheticRecordModelobj.nilOrallyDt,
            "yyyy-MM-dd"
          );
          this.GetAnestheticVitalDetailByIPDId(ipdid);
        } else {
          this.AnestheticVisitDetailModeldata = [];
          // this.clearAnthersiarecord();
        }
      },
      (err) => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      }
    );
  }
  AnestheticVisitDetailModeldata: AnestheticVisitDetailModel[] = [];
  GetAnestheticVitalDetailByIPDId(ipdid) {
    this.ipdService.GetAnestheticVitalDetailByIPDId(ipdid).pipe(takeUntil(this.destroyipd$)).subscribe(
      (item: any) => {
        this.AnestheticVisitDetailModeldata = [];
        if (item.length > 0) {
          this.AnestheticVisitDetailModeldata = item;
          this.AnestheticVisitDetailModeldata.map(
            (e) => (e.fK_ModifiedById = this.authService.Loggeduser.userid)
          );
          this.AnestheticVisitDetailModeldata.map(
            (e) => (e.modifiedBy = this.authService.Loggeduser.username)
          );
          this.AnestheticVisitDetailModeldata.map(
            (e) =>
            (e.modifiedDatetime = this.datePipe.transform(
              new Date(),
              "yyyy-MM-dd HH:mm:ss"
            ))
          );
        }
      },
      (err) => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      }
    );
  }

  rowClickedipdsurgery: number = -1;
  TablesurgeryColor(idx: any) {
    if (this.rowClickedipdsurgery === idx) {
      //  this.rowClickedipdsurgery = -1;
    } else {
      this.rowClickedipdsurgery = idx;
    }
  }

  CheckinputOpType1(event: any) {
    var checkdata = event.target.value;
    if (checkdata == "") {
      this.OpTypeControll();
      this.surgicalRecordobj.fK_OperationTypeId = null;
      this.surgicalRecordobj.operationTypeName = null;
    }
  }

  surgicalRecordArray: IPDsurgicalRecordModel[] = [];
  GetSurgeryOtRegister(ipdid) {
    if (ipdid > 0) {
      this.ipdService.GetSurgeryOtRegisterByIPDId(ipdid).pipe(takeUntil(this.destroyipd$)).subscribe(
        (x: any) => {
          this.surgicalRecordArray = [];
          this.surgicalRecordobj = {};
          if (x.length > 0) {
            this.surgicalRecordArray = x.reverse();
            for (var i = 0; i < x.length; i++) {
              this.surgicalRecordArray[i].surgeryDate = this.datePipe.transform(
                this.surgicalRecordArray[i].surgeryDate,
                "yyyy-MM-dd"
              );
              this.surgicalRecordArray[i].surgeryTime = this
                .surgicalRecordArray[i].surgeryTime
                ? moment(this.surgicalRecordArray[i].surgeryTime).format(
                  "h:mm A"
                )
                : null;
              this.surgicalRecordArray[i].initiatedTime = this
                .surgicalRecordArray[i].initiatedTime
                ? moment(this.surgicalRecordArray[i].initiatedTime).format(
                  "h:mm A"
                )
                : null;
              this.surgicalRecordArray[i].timedOut = this.surgicalRecordArray[i]
                .timedOut
                ? moment(this.surgicalRecordArray[i].timedOut).format("h:mm A")
                : null;
            }
            this.rowClickedipdsurgery = 0;
            this.surgicalRecordobj = this.surgicalRecordArray[0];

            if (this.surgicalRecordobj.pK_OTId > 0) {
              this.GetOtSurgeryByOTId(this.surgicalRecordobj.pK_OTId);
            }
          } else {
            this.addNewOTSurgical();
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          } 
          else if(err.error.statusCode == 422){
            this.dashboardService.openSnackBar(err.error.message,"OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
    }
  }
  anerTypeList = [];
  getAnaePopup() {
    this.counselorService.getAnarType().pipe(takeUntil(this.destroyipd$)).subscribe((data) => {
      this.anerTypeList = [];
      this.anerTypeList = data.filter((item) => item.isActive == true);
    },err =>{
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }

  getDiagonisisdatabyID() {
    this.emrservice.getDaigonosisbyRegid(this.RegId, 0, 0).pipe(takeUntil(this.destroyipd$)).subscribe(
      (x: any) => {
        if (x.length > 0) {
          x.forEach((item) => {
            if (
              this.surgicalRecordobj.diagnosis != null &&
              this.surgicalRecordobj.diagnosis != ""
            ) {
              this.surgicalRecordobj.diagnosis =
                this.surgicalRecordobj.diagnosis + item.diagnosisName + "\r\n";
            } else {
              this.surgicalRecordobj.diagnosis = item.diagnosisName + "\r\n";
            }
          });
        }
      },
      (err) => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
       }
    );
  }
  returnSurgoanName(sid) {
    return this.opdvisitService.doctors.filter((item) => item.userId == sid)[0]
      ?.userName;
  } 
  addNewOTSurgical() {
    this.getotsurgeryArray = [];
    this.surgicalRecordobj = {};
    this.rowClickedipdsurgery = -1;
    // this.surgicalRecordArray=[];
    if (this.selectCouncelorId > 0) {
      this.ipdService.getCounselordetailById(this.selectCouncelorId).pipe(takeUntil(this.destroyipd$)).subscribe(
        (item: any) => {
          this.surgicalRecordobj.isPostponed = item.isPostponed;
          this.surgicalRecordobj.fK_CounselorId = item.pK_CounselorId;
          this.surgicalRecordobj.fK_BranchId = item.fK_ForBranchId;
          this.surgicalRecordobj.fK_IPDId = Number(this.selectIpdId);
          this.surgicalRecordobj.surgeryDate = this.datePipe.transform(
            item.surgeryDate,
            "yyyy-MM-dd"
          );
          this.surgicalRecordobj.surgeryTime = moment(item.surgeryTime).format(
            "h:mm A"
          );
          this.surgicalRecordobj.fK_SurgenId = item.fK_MainSurgeronId;
          this.surgicalRecordobj.fK_OperationTypeId = item.fK_OperationTypeId;
          this.surgicalRecordobj.fK_AnesthTypeId = item.fK_AnesthTypeId;
          this.surgicalRecordobj.fK_AnaesthetistId = item.fK_AneastheticId;
          this.surgicalRecordobj.site = item.eye;
          this.surgicalRecordobj.otComplication = "NIL";
          this.surgicalRecordobj.fK_TheatherId = item.fK_TheatreId;
          this.surgicalRecordobj.isPostponed =
            item.postponed_Reason != null ? true : false;
          this.surgicalRecordobj.postPonedReasons = item.postponed_Reason;
          this.surgicalRecordobj.caseType = item.patientType;
          this.surgicalRecordobj.procedureName = item.procedureName;
          this.surgicalRecordobj.startTime = moment(
            this.authService.localDate
          ).format("h:mm A");
          this.surgicalRecordobj.finishTime = moment(
            this.authService.localDate
          ).format("h:mm A");
          this.surgicalRecordobj.isActive = true;
          this.surgicalRecordobj.procedureName = item.procedureName;
          this.surgicalRecordobj.fK_CreatedById = item.fK_AdvicedById;
          this.surgicalRecordobj.fK_CoSurgeonId = item.fK_CoSurgeronId;
          this.surgicalRecordobj.cosurgeonName = item.coSurgeon;
          this.surgicalRecordobj.cosurgeonName = item.anesthTypeName;
          this.surgicalRecordobj.fK_InitiatedbyId =
            this.authService.Loggeduser.userid;
          this.surgicalRecordobj.fK_TimeoutById =
            this.authService.Loggeduser.userid;
          this.surgicalRecordobj.initiatedTime = moment(
            this.authService.localDate
          ).format("h:mm A");
          this.surgicalRecordobj.timedOut = moment(
            this.authService.localDate
          ).format("h:mm A");
          this.surgicalRecordobj.surgeonName = item.surgeonName;
          this.surgicalRecordobj.theatreName = item.theatreName;
          this.surgicalRecordobj.anaesthetistName = item.operationTypeName;
          this.surgicalRecordobj.surgeryStatus = item.surgeryStatus;
          this.surgicalRecordobj.initiatedBy =
            this.authService.Loggeduser.username;
          this.surgicalRecordobj.timedoutBy =
            this.authService.Loggeduser.username;
          this.surgicalRecordobj.postPonedReasons = !item.postponed_Reason
            ? null
            : item.postponed_Reason;
          this.surgicalRecordobj.anesthTypeName = this.anerTypeList.filter(
            (itemdata) => itemdata.pkPopupId == item.fK_AnesthTypeId
          )[0]?.popupDescription;
          this.surgicalRecordobj.operationTypeName = this.getOPTypeArray.filter(
            (itema) => itema.pK_OperationTypeId == item.fK_OperationTypeId
          )[0]?.operationTypeName;
          this.getDiagonisisdatabyID();
          if (this.surgicalRecordobj.operationTypeName == "CATARACT") {
            this.surgicalRecordobj.isIOL = true;
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          } 
          else if(err.error.statusCode == 422){
            this.dashboardService.openSnackBar(err.error.message,"OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
      this.counselorService.getSurgeryById(this.selectCouncelorId).pipe(takeUntil(this.destroyipd$)).subscribe(
        (x: any) => {
          if (x.length > 0) {
            x.forEach((item) => {
              this.getotsurgeryArray.push({
                pK_OTSurgeryDetailId: 0,
                fK_OTId: 0,
                fK_SurgeryId: item.fK_SurgeryId,
                fK_SurgeonId: item.fK_SurgeonId,
                remarks: item.remarks,
                fK_QualifierId: null,
                oldotid: null,
                isEdit: false,
                isHidden: false,
                surgeryName: item.surgeryName,
                qualifierName: null,
                surgeon: this.returnSurgoanName(item.fK_SurgeonId),
                site: null,
                rightEyeSurgerycount: null,
                leftEyeSurgerycount: null,
                diagnosis: null,
              });
            });
          }
        },
        (err) => {
          // this.dashboardService.openSnackBar(
          //   "Counselor Surgery API FAILED",
          //   "OK"
          // );
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          } 
          else if(err.error.statusCode == 422){
            this.dashboardService.openSnackBar(err.error.message,"OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
    } else {
      this.surgicalRecordobj.initiatedBy = this.authService.Loggeduser.username;
      this.surgicalRecordobj.timedoutBy = this.authService.Loggeduser.username;
      this.surgicalRecordobj.fK_CreatedById =
        this.authService.Loggeduser.userid;
      this.surgicalRecordobj.fK_InitiatedbyId =
        this.authService.Loggeduser.userid;
      this.surgicalRecordobj.fK_TimeoutById =
        this.authService.Loggeduser.userid;
      this.surgicalRecordobj.fK_CounselorId = 0;
      this.surgicalRecordobj.isActive = true;
      this.surgicalRecordobj.fK_BranchId = this.authService.Loggeduser.branchid;
      this.surgicalRecordobj.fK_IPDId = Number(this.selectIpdId);
      this.surgicalRecordobj.surgeryDate = this.datePipe.transform(
        this.authService.localDate,
        "yyyy-MM-dd"
      );
      this.surgicalRecordobj.surgeryTime = moment(
        this.authService.localDate
      ).format("h:mm A");
      this.surgicalRecordobj.initiatedTime = moment(
        this.authService.localDate
      ).format("h:mm A");
      this.surgicalRecordobj.timedOut = moment(
        this.authService.localDate
      ).format("h:mm A");
    }
  }
  SelectRecord(obj) {
    this.surgicalRecordobj = {};
    this.surgicalRecordobj = obj;
    if (this.surgicalRecordobj.pK_OTId > 0) {
      this.GetOtSurgeryByOTId(this.surgicalRecordobj.pK_OTId);
    }
  }

// Drug Advice and Nursing Chart
GetNursingInstructionobj: NursingInstructionsModel = {};
GetNursingInstructiondata() {
  this.ipdService.GetNursingInstruction(this.selectIpdId).pipe(takeUntil(this.destroyipd$)).subscribe(
    (x: any) => {
      this.GetNursingInstructionobj = {};
      if (x.length > 0) {
        this.GetNursingInstructionobj = x[0];
      }
    },
    (err) => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    }
  );
}
  refIpdTypePOpup(type, type1?: any, checkid?: number) {
    const dialogRef = this.dialog.open(DynamicHelpListComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "33vw",
      disableClose: true,
      width: "33%",

      data: {
        parametertype: type,
      },
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroyipd$)).subscribe((result) => {
      if (result != 0) {
        if (type == "Complaints") {
          if (
            this.dischargeDatamodel.complaints != null &&
            this.dischargeDatamodel.complaints != ""
          ) {
            this.dischargeDatamodel.complaints =
              this.dischargeDatamodel.complaints + "," + result;
          } else {
            this.dischargeDatamodel.complaints = result;
          }
        } else if (type == "Procedures") {
          if (
            this.dischargeDatamodel.procedureDone != null &&
            this.dischargeDatamodel.procedureDone != ""
          ) {
            this.dischargeDatamodel.procedureDone =
              this.dischargeDatamodel.procedureDone + "," + result;
          } else {
            this.dischargeDatamodel.procedureDone = result;
          }
        } else if (type == "OPDDiagnosis") {
          if (
            this.dischargeDatamodel.diagnosis != null &&
            this.dischargeDatamodel.diagnosis != ""
          ) {
            this.dischargeDatamodel.diagnosis =
              this.dischargeDatamodel.diagnosis + "," + result;
          } else {
            this.dischargeDatamodel.diagnosis = result;
          }
        } else if (type == "DischargeRemarks" && type1 == 1) {
          if (
            this.dischargeDatamodel.remarks != null &&
            this.dischargeDatamodel.remarks != ""
          ) {
            this.dischargeDatamodel.remarks =
              this.dischargeDatamodel.remarks + "," + result;
          } else {
            this.dischargeDatamodel.remarks = result;
          }
        } else if (type == "DischargeRemarks" && type1 == 2) {
          if (
            this.dischargeDatamodel.prognosis != null &&
            this.dischargeDatamodel.prognosis != ""
          ) {
            this.dischargeDatamodel.prognosis =
              this.dischargeDatamodel.prognosis + "," + result;
          } else {
            this.dischargeDatamodel.prognosis = result;
          }
        } else if (type == "Systemic-Disease") {
          if (
            this.dischargeDatamodel.systemicIllness != null &&
            this.dischargeDatamodel.systemicIllness != ""
          ) {
            this.dischargeDatamodel.systemicIllness =
              this.dischargeDatamodel.systemicIllness + "," + result;
          } else {
            this.dischargeDatamodel.systemicIllness = result;
          }
        } else if (type == "ConditionAtDischarge") {
          if (
            this.dischargeDatamodel.conditiononDischarge != null &&
            this.dischargeDatamodel.conditiononDischarge != ""
          ) {
            this.dischargeDatamodel.conditiononDischarge =
              this.dischargeDatamodel.conditiononDischarge + "," + result;
          } else {
            this.dischargeDatamodel.conditiononDischarge = result;
          }
        } else if (type == "AdviceonDischarge") {
          if (
            this.dischargeDatamodel.adviceonDischarge != null &&
            this.dischargeDatamodel.adviceonDischarge != ""
          ) {
            this.dischargeDatamodel.adviceonDischarge =
              this.dischargeDatamodel.adviceonDischarge + "," + result;
          } else {
            this.dischargeDatamodel.adviceonDischarge = result;
          }
        } else if (type == "DoctorInstruction") {
          this.GetNursingInstructionobj.doctorinstructions = result;
        } else if (type == "NursingRemarks") {
          this.GetNursingInstructionobj.nursinginstructions = result;
        } else if (type == "Temp") {
          if (result <= 110) {
            this.GetNursingChartArray[type1].nTemp = result;
            this.GetNursingChartArray[type1].isEdit =
              checkid > 0 ? true : false;
            this.GetNursingChartArray[type1].isDelete = false;
          } else {
            this.GetNursingChartArray[type1].nTemp = null;
            this.GetNursingChartArray[type1].isEdit =
              checkid > 0 ? true : false;
            this.GetNursingChartArray[type1].isDelete = false;
          }
        } else if (type == "Pulse") {
          if (result <= 200) {
            this.GetNursingChartArray[type1].pulse = result;
            this.GetNursingChartArray[type1].isEdit =
              checkid > 0 ? true : false;
            this.GetNursingChartArray[type1].isDelete = false;
          } else {
            this.GetNursingChartArray[type1].pulse = null;
            this.GetNursingChartArray[type1].isEdit =
              checkid > 0 ? true : false;
            this.GetNursingChartArray[type1].isDelete = false;
          }
        } else if (type == "Resp.") {
          if (result <= 100) {
            this.GetNursingChartArray[type1].rr = result;
            this.GetNursingChartArray[type1].isEdit =
              checkid > 0 ? true : false;
            this.GetNursingChartArray[type1].isDelete = false;
          } else {
            this.GetNursingChartArray[type1].rr = null;
            this.GetNursingChartArray[type1].isEdit =
              checkid > 0 ? true : false;
            this.GetNursingChartArray[type1].isDelete = false;
          }
        } else if (type == "BPS") {
          if (result <= 100) {
            this.GetNursingChartArray[type1].bps = result;
            this.GetNursingChartArray[type1].isEdit =
              checkid > 0 ? true : false;
            this.GetNursingChartArray[type1].isDelete = false;
          } else {
            this.GetNursingChartArray[type1].bps = null;
            this.GetNursingChartArray[type1].isEdit =
              checkid > 0 ? true : false;
            this.GetNursingChartArray[type1].isDelete = false;
          }
        } else if (type == "BPD") {
          if (result <= 200) {
            this.GetNursingChartArray[type1].bpd = result;
            this.GetNursingChartArray[type1].isEdit =
              checkid > 0 ? true : false;
            this.GetNursingChartArray[type1].isDelete = false;
          } else {
            this.GetNursingChartArray[type1].bpd = null;
            this.GetNursingChartArray[type1].isEdit =
              checkid > 0 ? true : false;
            this.GetNursingChartArray[type1].isDelete = false;
          }
        } else if (type == "SpO2") {
          if (result <= 100) {
            this.GetNursingChartArray[type1].spO2 = result;
            this.GetNursingChartArray[type1].isEdit =
              checkid > 0 ? true : false;
            this.GetNursingChartArray[type1].isDelete = false;
          } else {
            this.GetNursingChartArray[type1].spO2 = null;
            this.GetNursingChartArray[type1].isEdit =
              checkid > 0 ? true : false;
            this.GetNursingChartArray[type1].isDelete = false;
          }
        } else if (type == "Weight") {
          if (result <= 500) {
            this.GetNursingChartArray[type1].weight = result;
            this.GetNursingChartArray[type1].isEdit =
              checkid > 0 ? true : false;
            this.GetNursingChartArray[type1].isDelete = false;
          } else {
            this.GetNursingChartArray[type1].weight = null;
            this.GetNursingChartArray[type1].isEdit =
              checkid > 0 ? true : false;
            this.GetNursingChartArray[type1].isDelete = false;
          }
        } else if (type == "RBS") {
          if (result <= 1000) {
            this.GetNursingChartArray[type1].nInPut = result;
            this.GetNursingChartArray[type1].isEdit =
              checkid > 0 ? true : false;
            this.GetNursingChartArray[type1].isDelete = false;
          } else {
            this.GetNursingChartArray[type1].nInPut = null;
            this.GetNursingChartArray[type1].isEdit =
              checkid > 0 ? true : false;
            this.GetNursingChartArray[type1].isDelete = false;
          }
        } else if (type == "PatientType") {
          this.surgicalRecordobj.caseType = result;
        } else if (type == "OTComplication") {
          this.surgicalRecordobj.otComplication = result;
        } else if (type == "AssistSister" && type1 == 1) {
          this.surgicalRecordobj.assistenceSister = result;
        } else if (type == "AssistSister" && type1 == 2) {
          this.surgicalRecordobj.gaNurse = result;
        } else if (type == "AssistSister" && type1 == 3) {
          this.surgicalRecordobj.circulatingNurse = result;
        } else if (type == "OTEYE") {
          this.surgicalRecordobj.site = result;
        } else if (type == "ANADIAGNOSIS") {
          if (
            this.PreopAssesmentRecordModelobj.diagnosis != null &&
            this.PreopAssesmentRecordModelobj.diagnosis != ""
          ) {
            this.PreopAssesmentRecordModelobj.diagnosis =
              this.PreopAssesmentRecordModelobj.diagnosis + "," + result;
          } else {
            this.PreopAssesmentRecordModelobj.diagnosis = result;
          }
        } else if (type == "ANAPROCEDURE") {
          if (
            this.PreopAssesmentRecordModelobj.procedureName != null &&
            this.PreopAssesmentRecordModelobj.procedureName != ""
          ) {
            this.PreopAssesmentRecordModelobj.procedureName =
              this.PreopAssesmentRecordModelobj.procedureName + "," + result;
          } else {
            this.PreopAssesmentRecordModelobj.procedureName = result;
          }
        } else if (type == "ANASYMPTOMS") {
          if (
            this.PreopAssesmentRecordModelobj.symptoms != null &&
            this.PreopAssesmentRecordModelobj.symptoms != ""
          ) {
            this.PreopAssesmentRecordModelobj.symptoms =
              this.PreopAssesmentRecordModelobj.symptoms + "," + result;
          } else {
            this.PreopAssesmentRecordModelobj.symptoms = result;
          }
        } else if (type == "ANAMEDICATION" && type1 == 2) {
          if (
            this.PreopAssesmentRecordModelobj.currentMedication != null &&
            this.PreopAssesmentRecordModelobj.currentMedication != ""
          ) {
            this.PreopAssesmentRecordModelobj.currentMedication =
              this.PreopAssesmentRecordModelobj.currentMedication +
              "," +
              result;
          } else {
            this.PreopAssesmentRecordModelobj.currentMedication = result;
          }
        } else if (type == "ANAMEDICATION" && type1 == 1) {
          if (
            this.PreopAssesmentRecordModelobj.previousMedication != null &&
            this.PreopAssesmentRecordModelobj.previousMedication != ""
          ) {
            this.PreopAssesmentRecordModelobj.previousMedication =
              this.PreopAssesmentRecordModelobj.previousMedication +
              "," +
              result;
          } else {
            this.PreopAssesmentRecordModelobj.previousMedication = result;
          }
        } else if (type == "HISTORYSURGERY") {
          if (
            this.PreopAssesmentRecordModelobj.historyOfSurgery != null &&
            this.PreopAssesmentRecordModelobj.historyOfSurgery != ""
          ) {
            this.PreopAssesmentRecordModelobj.historyOfSurgery =
              this.PreopAssesmentRecordModelobj.historyOfSurgery + "," + result;
          } else {
            this.PreopAssesmentRecordModelobj.historyOfSurgery = result;
          }
        } else if (type == "MEDICALSTATUS") {
          if (
            this.PreopAssesmentRecordModelobj.medicalStatus != null &&
            this.PreopAssesmentRecordModelobj.medicalStatus != ""
          ) {
            this.PreopAssesmentRecordModelobj.medicalStatus =
              this.PreopAssesmentRecordModelobj.medicalStatus + "," + result;
          } else {
            this.PreopAssesmentRecordModelobj.medicalStatus = result;
          }
        } else if (type == "MEDICALTREATMENT") {
          if (
            this.PreopAssesmentRecordModelobj.medicalTreatment != null &&
            this.PreopAssesmentRecordModelobj.medicalTreatment != ""
          ) {
            this.PreopAssesmentRecordModelobj.medicalTreatment =
              this.PreopAssesmentRecordModelobj.medicalTreatment + "," + result;
          } else {
            this.PreopAssesmentRecordModelobj.medicalTreatment = result;
          }
        } else if (type == "DENTITATION") {
          this.AnestheticRecordModelobj.dentitation = result;
        } else if (type == "OBESITY") {
          this.AnestheticRecordModelobj.obesity = result;
        } else if (type == "ASA") {
          this.AnestheticRecordModelobj.asa = result;
        } else if (type == "ICTERUS") {
          this.AnestheticRecordModelobj.ictras = result;
        } else if (type == "MOUNTH") {
          this.AnestheticRecordModelobj.mouthOpening = result;
        } else if (type == "PREOPSPO2") {
          this.AnestheticRecordModelobj.preopSpo2 = result;
        } else if (type == "POLLAR") {
          this.AnestheticRecordModelobj.pollar = result;
        } else if (type == "CYNOSIS") {
          this.AnestheticRecordModelobj.cynosis = result;
        } else if (type == "NECT") {
          this.AnestheticRecordModelobj.neckMove = result;
        } else if (type == "LYMPHADENOPATHY") {
          this.AnestheticRecordModelobj.lymphadenopathy = result;
        } else if (type == "CLUBBING") {
          this.AnestheticRecordModelobj.clubbing = result;
        } else if (type == "JVP") {
          this.AnestheticRecordModelobj.jvp = result;
        } else if (type == "MPC") {
          this.AnestheticRecordModelobj.mpc = result;
        } else if (type == "ANASPLANED") {
          this.AnestheticRecordModelobj.anasPlaned = result;
        } else if (type == "EDEMA") {
          this.AnestheticRecordModelobj.edesma = result;
        } else if (type == "PRE-OPCHECKUP") {
          if (
            this.AnestheticRecordModelobj.preAnasChUp != null &&
            this.AnestheticRecordModelobj.preAnasChUp != ""
          ) {
            this.AnestheticRecordModelobj.preAnasChUp =
              this.AnestheticRecordModelobj.preAnasChUp + "," + result;
          } else {
            this.AnestheticRecordModelobj.preAnasChUp = result;
          }
        } else if (type == "PRE-OPMEDICATION") {
          if (
            this.AnestheticRecordModelobj.preMedication != null &&
            this.AnestheticRecordModelobj.preMedication != ""
          ) {
            this.AnestheticRecordModelobj.preMedication =
              this.AnestheticRecordModelobj.preMedication + "," + result;
          } else {
            this.AnestheticRecordModelobj.preMedication = result;
          }
        } else if (type == "PRE-OPREMARKS") {
          if (
            this.AnestheticRecordModelobj.preOpRemark != null &&
            this.AnestheticRecordModelobj.preOpRemark != ""
          ) {
            this.AnestheticRecordModelobj.preOpRemark =
              this.AnestheticRecordModelobj.preOpRemark + "," + result;
          } else {
            this.AnestheticRecordModelobj.preOpRemark = result;
          }
        } else if (type == "PRE-OPINDUCTION") {
          if (
            this.AnestheticRecordModelobj.induction != null &&
            this.AnestheticRecordModelobj.induction != ""
          ) {
            this.AnestheticRecordModelobj.induction =
              this.AnestheticRecordModelobj.induction + "," + result;
          } else {
            this.AnestheticRecordModelobj.induction = result;
          }
        } else if (type == "PRE-OPMAINTENANCE") {
          if (
            this.AnestheticRecordModelobj.maintenance != null &&
            this.AnestheticRecordModelobj.maintenance != ""
          ) {
            this.AnestheticRecordModelobj.maintenance =
              this.AnestheticRecordModelobj.maintenance + "," + result;
          } else {
            this.AnestheticRecordModelobj.maintenance = result;
          }
        } else if (type == "PRE-REVERSAL") {
          if (
            this.AnestheticRecordModelobj.reversal != null &&
            this.AnestheticRecordModelobj.reversal != ""
          ) {
            this.AnestheticRecordModelobj.reversal =
              this.AnestheticRecordModelobj.reversal + "," + result;
          } else {
            this.AnestheticRecordModelobj.reversal = result;
          }
        } else if (type == "MONITORING") {
          if (
            this.AnestheticRecordModelobj.monitoring != null &&
            this.AnestheticRecordModelobj.monitoring != ""
          ) {
            this.AnestheticRecordModelobj.monitoring =
              this.AnestheticRecordModelobj.monitoring + "," + result;
          } else {
            this.AnestheticRecordModelobj.monitoring = result;
          }
        } else if (type == "ANACOMPLICATIONS") {
          if (
            this.AnestheticRecordModelobj.complications != null &&
            this.AnestheticRecordModelobj.complications != ""
          ) {
            this.AnestheticRecordModelobj.complications =
              this.AnestheticRecordModelobj.complications + "," + result;
          } else {
            this.AnestheticRecordModelobj.complications = result;
          }
        } else if (type1 == "HistoryDisease" && checkid >= 0) {
          this.getpreopAssesmentHistory[checkid].resultValue = result;
        } else if (type1 == "PhysicalExaminations" && checkid >= 0) {
          this.getpreopAssesmentPhysical[checkid].resultValue = result;
        } else if (type1 == "LabInvestigation" && checkid >= 0) {
          this.getpreopAssesmentLab[checkid].resultValue = result;
        }
      }
    });
  }
  PreopAssesmentRecordModelobj: PreopAssesmentRecordModel = {};
  // PreopAssesmentRecordindication: boolean = false;
  GetPreOpAssesmentRecord(regid, ipdid) {
    this.ipdService
      .GetPreOpAssesmentRecordByRegIdByIPDId(regid, ipdid).pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          this.PreopAssesmentRecordModelobj = {};
          if (x.length > 0) {
            this.PreopAssesmentRecordindication = true;
            this.PreopAssesmentRecordModelobj = x[0];
            this.PreopAssesmentRecordModelobj.isEdit = true;

            this.GetPreOpAssesmentDetailByMaster(
              "HISTORY",
              this.RegId,
              this.selectIpdId
            );
            this.GetPreOpAssesmentDetailByPhysical(
              "PHYSICAL EXAMINATION",
              this.RegId,
              this.selectIpdId
            );
            this.GetPreOpAssesmentDetailByLab(
              "LAB",
              this.RegId,
              this.selectIpdId
            );
            this.GetPreOpAssesmentDetailByDIAGNOSTIC(
              "DIAGNOSTIC",
              this.RegId,
              this.selectIpdId
            );
          } else {
            this.PreopAssesmentRecordModelobj.pK_TranID = 0;
            this.PreopAssesmentRecordModelobj.fK_IPDID = this.selectIpdId;
            this.PreopAssesmentRecordModelobj.fK_REGID = this.RegId;
            this.PreopAssesmentRecordModelobj.isEdit = false;
            this.GetPreOpAssesmentDetailBytype("HISTORY");
            this.GetPreOpAssesmentPhysical("PHYSICAL EXAMINATION");
            this.GetPreOpAssesmentLab("LAB");
            this.GetPreOpAssesmentDiagnosis("DIAGNOSTIC");
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          } 
          else if(err.error.statusCode == 422){
            this.dashboardService.openSnackBar(err.error.message,"OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  GetPreOpAssesmentDiagnosis(type) {
    this.ipdService.GetPreOpAssesmentMasterByMasterType(type).pipe(takeUntil(this.destroyipd$)).subscribe(
      (x: any) => {
        this.getpreopAssesmentDiagnosis = [];
        if (x.length > 0) {
          x.forEach((element) => {
            this.getpreopAssesmentDiagnosis.push({
              pK_TranID: 0,
              fK_IPDID: this.selectIpdId,
              masterType: element.masterType,
              seqNo: element.seqNo,
              fieldName: element.fieldName,
              resultValue: element.defaultValue,
              fK_REGID: this.RegId,
              isHighLight: element.isHighLight,
              isEdit: false,
            });
          });
        }
      },
      (err) => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      }
    );
  }
  getpreopAssesmentDiagnosis: GetPreOpAssesmentDetailHistroy[] = [];
  GetPreOpAssesmentDetailByDIAGNOSTIC(type, regid, ipdid) {
    this.ipdService
      .GetPreOpAssesmentDetailByMaster(type, regid, ipdid).pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          this.getpreopAssesmentDiagnosis = [];
          if (x.length > 0) {
            this.getpreopAssesmentDiagnosis = x;
            this.getpreopAssesmentDiagnosis.map((item) => (item.isEdit = true));
            this.getpreopAssesmentDiagnosis.map(
              (item) => (item.isHighLight = 0)
            );
          } else {
            this.GetPreOpAssesmentDiagnosis(type);
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          } 
          else if(err.error.statusCode == 422){
            this.dashboardService.openSnackBar(err.error.message,"OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  getpreopAssesmentHistory: GetPreOpAssesmentDetailHistroy[] = [];
  GetPreOpAssesmentDetailByMaster(type, regid, ipdid) {
    this.ipdService
      .GetPreOpAssesmentDetailByMaster(type, regid, ipdid).pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          this.getpreopAssesmentHistory = [];
          if (x.length > 0) {
            this.getpreopAssesmentHistory = x;
            this.getpreopAssesmentHistory.map((item) => (item.isEdit = true));
            this.getpreopAssesmentHistory.map((item) => (item.isHighLight = 0));
          } else {
            this.GetPreOpAssesmentDetailBytype(type);
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          } 
          else if(err.error.statusCode == 422){
            this.dashboardService.openSnackBar(err.error.message,"OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  GetPreOpAssesmentDetailBytype(type) {
    this.ipdService.GetPreOpAssesmentMasterByMasterType(type).pipe(takeUntil(this.destroyipd$)).subscribe(
      (x: any) => {
        this.getpreopAssesmentHistory = [];
        if (x.length > 0) {
          x.forEach((element) => {
            this.getpreopAssesmentHistory.push({
              pK_TranID: 0,
              fK_IPDID: this.selectIpdId,
              masterType: element.masterType,
              seqNo: element.seqNo,
              fieldName: element.fieldName,
              resultValue: element.defaultValue,
              fK_REGID: this.RegId,
              isHighLight: element.isHighLight,
              isEdit: false,
            });
          });
        }
      },
      (err) => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      }
    );
  }
  GetPreOpAssesmentLab(type) {
    this.ipdService.GetPreOpAssesmentMasterByMasterType(type).pipe(takeUntil(this.destroyipd$)).subscribe(
      (x: any) => {
        this.getpreopAssesmentLab = [];
        if (x.length > 0) {
          x.forEach((element) => {
            this.getpreopAssesmentLab.push({
              pK_TranID: 0,
              fK_IPDID: this.selectIpdId,
              masterType: element.masterType,
              seqNo: element.seqNo,
              fieldName: element.fieldName,
              resultValue: element.defaultValue,
              fK_REGID: this.RegId,
              isHighLight: element.isHighLight,
              isEdit: false,
            });
          });
        }
      },
      (err) => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      }
    );
  }

  getpreopAssesmentPhysical: GetPreOpAssesmentDetailHistroy[] = [];
  GetPreOpAssesmentDetailByPhysical(type, regid, ipdid) {
    this.ipdService
      .GetPreOpAssesmentDetailByMaster(type, regid, ipdid).pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          this.getpreopAssesmentPhysical = [];
          if (x.length > 0) {
            this.getpreopAssesmentPhysical = x;
            this.getpreopAssesmentPhysical.map((item) => (item.isEdit = true));
            this.getpreopAssesmentPhysical.map(
              (item) => (item.isHighLight = 0)
            );
          } else {
            this.GetPreOpAssesmentPhysical(type);
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          } 
          else if(err.error.statusCode == 422){
            this.dashboardService.openSnackBar(err.error.message,"OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  GetPreOpAssesmentPhysical(type) {
    this.ipdService.GetPreOpAssesmentMasterByMasterType(type).pipe(takeUntil(this.destroyipd$)).subscribe(
      (x: any) => {
        this.getpreopAssesmentPhysical = [];
        if (x.length > 0) {
          x.forEach((element) => {
            this.getpreopAssesmentPhysical.push({
              pK_TranID: 0,
              fK_IPDID: this.selectIpdId,
              masterType: element.masterType,
              seqNo: element.seqNo,
              fieldName: element.fieldName,
              resultValue: element.defaultValue,
              fK_REGID: this.RegId,
              isHighLight: element.isHighLight,
              isEdit: false,
            });
          });
        }
      },
      (err) => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      }
    );
  }
  getpreopAssesmentLab: GetPreOpAssesmentDetailHistroy[] = [];
  GetPreOpAssesmentDetailByLab(type, regid, ipdid) {
    this.ipdService
      .GetPreOpAssesmentDetailByMaster(type, regid, ipdid).pipe(takeUntil(this.destroyipd$))
      .subscribe(
        (x: any) => {
          this.getpreopAssesmentLab = [];
          if (x.length > 0) {
            this.getpreopAssesmentLab = x;
            this.getpreopAssesmentLab.map((item) => (item.isEdit = true));
            this.getpreopAssesmentLab.map((item) => (item.isHighLight = 0));
          } else {
            this.GetPreOpAssesmentLab(type);
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          } 
          else if(err.error.statusCode == 422){
            this.dashboardService.openSnackBar(err.error.message,"OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }

  saveOtiolArray: IpdIolModel = {};
  iolModal(type) {
    this.ipdService.getOtiolsaveData(this.selectIpdId).pipe(takeUntil(this.destroyipd$)).subscribe((x: any) => {
      if (type == 0) {
        document.getElementById("iolModal").style.display = "block";
      }
      if (x.length > 0) {
        this.saveOtiolArray = {};
        this.saveOtiolArray = x[0];
        this.saveOtiolArray.isEdit = true;
        this.saveOtiolArray.site = this.surgicalRecordobj?.site == null ? this.surgicalRecordobj?.site : this.surgicalRecordobj?.site;
        this.getIolDetail();
      } else {
        this.setdata();
      }

    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }
  setdata() {
    this.saveOtiolArray.isEdit = false;
    this.saveOtiolArray.pK_IOLId = 0;
    this.saveOtiolArray.fK_IPDId = Number(this.selectIpdId);
    this.saveOtiolArray.isAcitve = true;
    this.saveOtiolArray.site = this.surgicalRecordobj?.site ? this.surgicalRecordobj?.site : null;
    this.saveOtiolArray.k1R = null;
    this.saveOtiolArray.k2R = null;
    this.saveOtiolArray.axis = null;
    this.saveOtiolArray.k2Axis = null;
    this.saveOtiolArray.alx = null;
    this.saveOtiolArray.aConstant = null;
    this.saveOtiolArray.power = null;
    this.saveOtiolArray.aConstant2 = null;
    this.saveOtiolArray.power2 = null;
    this.saveOtiolArray.acpc = null;
    this.saveOtiolArray.typeofIOL = null;
    this.saveOtiolArray.modelCompany = null;
    this.saveOtiolArray.finalPower = null;
    this.saveOtiolArray.opSize = null;
    this.saveOtiolArray.plano = null;
    this.saveOtiolArray.needtoDiscuss = false;
    this.saveOtiolArray.iolRemarks = null;
    this.saveOtiolArray.machineName = null;
    this.saveOtiolArray.oldipdId = null;
    this.saveOtiolArray.lensThickness = null;
    this.saveOtiolArray.acd = null;
    this.saveOtiolArray.specularMicroscopy = null;
    this.saveOtiolArray.hexagonality = null;
    this.saveOtiolArray.cellDensity = null;
    this.saveOtiolArray.cellCount = null;
    this.getIolDetail();
  }
  changedata(name: any, srno, i) {
    if (srno == 1) {
      this.detailiolArray[i].k1R = name;
      this.saveOtiolArray.k1R = name;
    } else if (srno == 2) {
      this.detailiolArray[i].k2R = name;
      this.saveOtiolArray.k2R = name;
    } else if (srno == 3) {
      this.detailiolArray[i].axis = name;
      this.saveOtiolArray.axis = name;
    } else if (srno == 4) {
      this.detailiolArray[i].k2Axis = name;
      this.saveOtiolArray.k2Axis = name;
    } else if (srno == 5) {
      this.detailiolArray[i].alx = name;
      this.saveOtiolArray.alx = name;
    } else if (srno == 6) {
      this.detailiolArray[i].aConstant = name;
      this.saveOtiolArray.aConstant = name;
    } else if (srno == 7) {
      this.detailiolArray[i].power = name;
      this.saveOtiolArray.power = name;
    } else if (srno == 8) {
      this.detailiolArray[i].aConstant2 = name;
      this.saveOtiolArray.aConstant2 = name;
    } else if (srno == 9) {
      this.detailiolArray[i].power2 = name;
      this.saveOtiolArray.power2 = name;
    } else if (srno == 10) {
      this.detailiolArray[i].acpc = name;
      this.saveOtiolArray.acpc = name;
    } else if (srno == 11) {
      this.detailiolArray[i].typeofIOL = name;
      this.saveOtiolArray.typeofIOL = name;
    } else if (srno == 12) {
      this.detailiolArray[i].modelCompany = name;
      this.saveOtiolArray.modelCompany = name;
    } else if (srno == 13) {
      this.detailiolArray[i].finalPower = name;
      this.saveOtiolArray.finalPower = name;
    } else if (srno == 14) {
      this.detailiolArray[i].opSize = name;
      this.saveOtiolArray.opSize = name;
    } else if (srno == 15) {
      this.detailiolArray[i].plano = name;
      this.saveOtiolArray.plano = name;
    } else if (srno == 16) {
      this.detailiolArray[i].machineName = name;
      this.saveOtiolArray.machineName = name;
    } else if (srno == 17) {
      this.detailiolArray[i].lensThickness = name;
      this.saveOtiolArray.lensThickness = name;
    } else if (srno == 18) {
      this.detailiolArray[i].acd = name;
      this.saveOtiolArray.acd = name;
    } else if (srno == 19) {
      this.detailiolArray[i].specularMicroscopy = name;
      this.saveOtiolArray.specularMicroscopy = name;
    } else if (srno == 20) {
      this.detailiolArray[i].hexagonality = name;
      this.saveOtiolArray.hexagonality = name;
    } else if (srno == 21) {
      this.detailiolArray[i].cellDensity = name;
      this.saveOtiolArray.cellDensity = name;
    } else if (srno == 22) {
      this.detailiolArray[i].cellCount = name;
      this.saveOtiolArray.cellCount = name;
    }
  }

  anesthTpyePOpup(type) {
    this.getAnaePopup();
    const dialogRef = this.dialog.open(HelpListPopupComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "33vw",
      disableClose: true,
      width: "33%",
      data: {
        typeid: type,
      },
    });
    dialogRef.afterClosed().pipe(takeUntil(this.destroyipd$)).subscribe((result) => {
      if (result != 0) {
        if (type == 2) {
          this.surgicalRecordobj.anesthTypeName = result;
          let atypeId = this.anerTypeList.filter(
            (item) => item.popupDescription == result
          )[0];
          this.surgicalRecordobj.fK_AnesthTypeId = atypeId.pkPopupId;
        }
      }
    });
  }


  saveIoLData() {

    if (this.saveOtiolArray) {
      this.saveOtiolArray.site = this.saveOtiolArray.site.slice(0, 1);
    }
    let payload = {
      "OtIolPowerDetail": this.saveOtiolArray
    }
    this.ipdService.insertOtiolData(payload).pipe(takeUntil(this.destroyipd$)).subscribe((x: any) => {
      this.dashboardService.openSnackBar(this.saveOtiolArray.pK_IOLId == 0 ? "Record Saved Successfully" : "Record Updated Successfully", "ok");
      this.iolModal(1);
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }
  detailiolArray: any = [];
  getIolDetail() {
    this.detailiolArray = [];
    this.detailiolArray = [
      { "srno": 1, "name": 'K1 Reading', "righteye": this.saveOtiolArray.k1R, "enable": true },
      { "srno": 2, "name": 'K2 Reading', "righteye": this.saveOtiolArray.k2R, "enable": true },
      { "srno": 3, "name": 'K1-Axis', "righteye": this.saveOtiolArray.axis, "enable": true },
      { "srno": 4, "name": 'K2-Axis', "righteye": this.saveOtiolArray.k2Axis, "enable": true },
      { "srno": 5, "name": 'Axial Length', "righteye": this.saveOtiolArray.alx, "enable": true },
      { "srno": 6, "name": 'A-Constant', "righteye": this.saveOtiolArray.aConstant, "enable": true },
      { "srno": 7, "name": 'Power', "righteye": this.saveOtiolArray.power, "enable": true },
      { "srno": 8, "name": 'A-Constant', "righteye": this.saveOtiolArray.aConstant2, "enable": true },
      { "srno": 9, "name": 'Power', "righteye": this.saveOtiolArray.power2, "enable": true },
      { "srno": 10, "name": 'AC/PC', "righteye": this.saveOtiolArray.acpc, "enable": true },
      { "srno": 11, "name": 'Type of IOL', "righteye": this.saveOtiolArray.typeofIOL, "enable": true },
      { "srno": 12, "name": 'Company of IOL', "righteye": this.saveOtiolArray.modelCompany, "enable": true },
      { "srno": 13, "name": 'Final Power', "righteye": this.saveOtiolArray.finalPower, "enable": true },
      { "srno": 14, "name": 'Optic Dioptor', "righteye": this.saveOtiolArray.opSize, "enable": true },
      { "srno": 15, "name": 'Plano/Bio', "righteye": this.saveOtiolArray.plano, "enable": true },
      { "srno": 16, "name": 'MachineName', "righteye": this.saveOtiolArray.machineName, "enable": true },
      { "srno": 17, "name": 'LensThickNess', "righteye": this.saveOtiolArray.lensThickness, "enable": true },
      { "srno": 18, "name": 'ACD', "righteye": this.saveOtiolArray.acd, "enable": true },
      { "srno": 19, "name": 'SpecularMicroscopy', "righteye": this.saveOtiolArray.specularMicroscopy, "enable": true },
      { "srno": 20, "name": 'Hexagonality', "righteye": this.saveOtiolArray.hexagonality, "enable": true },
      { "srno": 21, "name": 'CellDensity', "righteye": this.saveOtiolArray.cellDensity, "enable": true },
      { "srno": 22, "name": 'CellCount', "righteye": this.saveOtiolArray.cellCount, "enable": true }];


  }

  getdeletedischageSurgery: OtRecordSurgeryModel[] = [];
  removeSurgery(row, index: number) {
    this.getotsurgeryArray.splice(index, 1);
    if (row.pK_OTSurgeryDetailId > 0) {
      this.getdeletedischageSurgery.push(row);
      this.getdeletedischageSurgery.map((item) => (item.isEdit = true));
      this.getdeletedischageSurgery.map((item) => (item.isHidden = true));
    }
  }
  InsertOtRegisterdata() {
    if (!this.surgicalRecordobj.fK_BranchId) {
      this.showspinner1 = false;
      return this.dashboardService.openSnackBar(
        "Please Select Branch Name",
        "OK"
      );
    } else if (!this.surgicalRecordobj.surgeryStatus) {
      this.showspinner1 = false;
      return this.dashboardService.openSnackBar(
        "Please Select Surgery Status",
        "OK"
      );
    } else if (!this.surgicalRecordobj.caseType) {
      this.showspinner1 = false;
      return this.dashboardService.openSnackBar(
        "Please Select Case Type",
        "OK"
      );
    } else if (!this.surgicalRecordobj.operationTypeName) {
      this.showspinner1 = false;
      return this.dashboardService.openSnackBar(
        "Please Select Operation Type",
        "OK"
      );
    } else if (!this.surgicalRecordobj.otComplication) {
      this.showspinner1 = false;
      return this.dashboardService.openSnackBar(
        "Please Select OT Complication, If NIL Also Put NIL",
        "OK"
      );
    } else if (!this.surgicalRecordobj.anaesthetistName) {
      this.showspinner1 = false;
      return this.dashboardService.openSnackBar(
        "Please Select Anaesthetist Type",
        "OK"
      );
    } else if (
      !this.surgicalRecordobj.theatreName ||
      this.surgicalRecordobj.fK_TheatherId == null
    ) {
      this.showspinner1 = false;
      return this.dashboardService.openSnackBar(
        "Please Select Theatre Name",
        "OK"
      );
    } else if (!this.surgicalRecordobj.surgeonName) {
      this.showspinner1 = false;
      return this.dashboardService.openSnackBar(
        "Please Select Surgeon Name",
        "OK"
      );
    } else if (!this.surgicalRecordobj.site) {
      this.showspinner1 = false;
      return this.dashboardService.openSnackBar(
        "Please Select Surgery Eye",
        "OK"
      );
    } else if (this.getotsurgeryArray.length == 0) {
      this.showspinner1 = false;
      return this.dashboardService.openSnackBar(
        "Please Select At Least one Surgery",
        "OK"
      );
    }
    if (this.surgicalRecordobj.pK_OTId > 0) {
      this.surgicalRecordobj.isEdit = true;
    } else {
      this.surgicalRecordobj.pK_OTId = 0;
      this.surgicalRecordobj.isEdit = false;
    }
    this.surgicalRecordobj.fK_AnesthTypeId = !this.surgicalRecordobj
      .fK_AnesthTypeId
      ? null
      : this.surgicalRecordobj.fK_AnesthTypeId;
    this.surgicalRecordobj.anesthTypeName = !this.surgicalRecordobj
      .anesthTypeName
      ? null
      : this.surgicalRecordobj.anesthTypeName;
    this.surgicalRecordobj.anaeGivenNofofTime = !this.surgicalRecordobj
      .anaeGivenNofofTime
      ? null
      : this.surgicalRecordobj.anaeGivenNofofTime;
    this.surgicalRecordobj.xylocain = !this.surgicalRecordobj.xylocain
      ? false
      : this.surgicalRecordobj.xylocain;
    this.surgicalRecordobj.xylocainQty = !this.surgicalRecordobj.xylocainQty
      ? null
      : this.surgicalRecordobj.xylocainQty;
    this.surgicalRecordobj.gaNurse = !this.surgicalRecordobj.gaNurse
      ? null
      : this.surgicalRecordobj.gaNurse;
    this.surgicalRecordobj.circulatingNurse = !this.surgicalRecordobj
      .circulatingNurse
      ? null
      : this.surgicalRecordobj.circulatingNurse;
    this.surgicalRecordobj.procedureName = !this.surgicalRecordobj.procedureName
      ? null
      : this.surgicalRecordobj.procedureName;
    this.surgicalRecordobj.remark = !this.surgicalRecordobj.remark
      ? null
      : this.surgicalRecordobj.remark;
    this.surgicalRecordobj.isPostponed = !this.surgicalRecordobj.isPostponed
      ? false
      : this.surgicalRecordobj.isPostponed;
    this.surgicalRecordobj.postPonedReasons = !this.surgicalRecordobj
      .postPonedReasons
      ? null
      : this.surgicalRecordobj.postPonedReasons;
    this.surgicalRecordobj.manualOTNo = !this.surgicalRecordobj.manualOTNo
      ? null
      : this.surgicalRecordobj.manualOTNo;
    this.surgicalRecordobj.fK_CounselorId = !this.selectCouncelorId
      ? 0
      : this.selectCouncelorId;
    this.surgicalRecordobj.surgeryDate = this.datePipe.transform(
      this.surgicalRecordobj.surgeryDate,
      "yyyy-MM-dd"
    );
    this.surgicalRecordobj.surgeryTime = moment(
      this.surgicalRecordobj.surgeryTime,
      ["h:mm A"]
    ).format("HH:mm");
    this.surgicalRecordobj.initiatedTime = moment(
      this.surgicalRecordobj.initiatedTime,
      ["h:mm A"]
    ).format("HH:mm");
    this.surgicalRecordobj.timedOut = moment(this.surgicalRecordobj.timedOut, [
      "h:mm A",
    ]).format("HH:mm");
    let payload = {
      OtRegister: this.surgicalRecordobj,
      OtRecordSurgery: this.getotsurgeryArray.concat(
        this.getdeletedischageSurgery
      ),
      OtIolPowerDetail: {},
    };
    this.ipdService.InsertOtRegister(payload).pipe(takeUntil(this.destroyipd$)).subscribe(
      (x: any) => {
        this.showspinner1 = false;
        if (this.surgicalRecordobj.pK_OTId > 0) {
          this.dashboardService.openSnackBar(
            "Record Updated Successfully",
            "OK"
          );
        } else {
          this.dashboardService.openSnackBar("Record Saved Successfully", "OK");

          // if (
          //   this.opdvisitService.patientdetails.mobileNo != "" &&
          //   this.opdvisitService.patientdetails.mobileNo != null &&
          //   this.opdvisitService.patientdetails.mobileNo != undefined
          // ) {
          //   var result = this.opdvisitService.doctors.filter(
          //     (x) => x.userId === this.corporateData.fK_ConsultantId
          //   );
          //   this.opdvisitService.datasendsms.PatientName =
          //     this.opdvisitService.patientdetails.firstName +
          //     " " +
          //     this.opdvisitService.patientdetails.lastName;
          //   this.opdvisitService.datasendsms.MobileNo =
          //     this.opdvisitService.patientdetails.mobileNo;
          //   this.opdvisitService.datasendsms.MrdNo =
          //     this.opdvisitService.patientdetails.pkRegId;
          //   this.opdvisitService.datasendsms.SeqNo = null;
          //   this.opdvisitService.datasendsms.ApptDate = null;
          //   this.opdvisitService.datasendsms.ApptTime = null;
          //   this.opdvisitService.datasendsms.ApptConsultant =
          //     result[0].userName;
          //   this.opdvisitService.datasendsms.SurgeryDate =
          //     this.surgicalRecordobj.surgeryDate;
          //   this.opdvisitService.datasendsms.SurgeryTime =
          //     this.surgicalRecordobj.surgeryTime;
          //   this.opdvisitService.datasendsms.BranchId =
          //     this.authService.Loggeduser.branchid;
          //   this.opdvisitService.datasendsms.SMSType = "SURGERYBOOKING";
          //   this.opdvisitService.sendSMstoPatient(
          //     this.opdvisitService.datasendsms
          //   );
          // }
        }
        this.GetSurgeryOtRegister(this.selectIpdId);
      },
      (err) => {
        this.showspinner1 = false;
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      }
    );
  }

  theatreModalDialog() {
    document.getElementById("theatreModal").style.display = "block";
  }
  closetheatreModalDialog() {
    document.getElementById("theatreModal").style.display = "none";
  }

  //Assistant Doctor Modal
  assistantDoctorModalDialog() {
    document.getElementById("assistantDoctorModal").style.display = "block";
  }
  closeassistantDoctorModalDialog() {
    document.getElementById("assistantDoctorModal").style.display = "none";
  }
  Editioldata(i) {
    this.detailiolArray[i].enable = false;
  }
  closeiolEdit(i) {
    this.detailiolArray[i].enable = true;
  }
  closeIOLModal() {
    document.getElementById("iolModal").style.display = "none";
  }
  closedialog(){
    this.dialogRef.close();
  }
}
